export const messages = {
  "settings.title": "Profildaten",
  "settings.name": "Name",
  "settings.password": "Passwort",
  "settings.mail": "Email",
  "settings.phone": "Telefon",
  "settings.address": "Rechnungsadresse",
  "settings.button.close": "Schließen",
  "settings.button.save": "Speichern",
  "settings.edit": "Profil Bearbeiten",
  "settings.logout": "Ausloggen",
  "settings.nodata": "nicht eingegeben",
  "settings.tradingName": "Firmenname",
  "settings.language": "Sprache",
  "settings.areaUnit": "Flächeneinheit",
  "settings.areaUnit.hectares": "Hektar (ha)",
  "settings.areaUnit.acres": "Acres (ac)",
  "settings.button.edit": "Bearbeiten",
  "settings.button.cancel": "Abbrechen",
  "settings.changePassword": "Passwort ändern",
  "settings.newPassword": "Neues Passwort",
  "settings.confirmPassword": "Neues Passwort bestätigen",
  "settings.password.hint":
    "Leer lassen, um das aktuelle Passwort beizubehalten",
  "settings.password.mismatch": "Passwörter stimmen nicht überein",
  "settings.name.required": "Name ist erforderlich",
  "settings.mail.invalid": "Bitte eine gültige Email-Adresse eingeben",
  "settings.update.success": "Profil aktualisiert",
  "settings.update.error":
    "Profil konnte nicht aktualisiert werden. Bitte erneut versuchen.",
  "passwordChange.success": "Passwort geändert",
  "login.heading": "Weidemanagement App",
  "login.dialog.title": "Anmelden",
  "login.dialog.reset": "Passwort Vergessen",
  "login.reset.popover": "Bitte schreibe eine Email an hello@ruumi.io",
  "login.dialog.signup": "Neu Registrieren",
  "login.mail.label": "Email",
  "login.password.label": "Passwort",
  "login.button.label": "Einloggen",
  "signup.heading": "Weidemanagement App",
  "signup.dialogTitle.userDetails": "Gib deine Details ein",
  "signup.dialogTitle.farmDetails": "Erzähl uns über dein Hof",
  "signup.button.signup": "Registrieren",
  "signup.button.next": "Weiter",
  "signup.button.back": "Zurück",
  "signup.button.getStarted": "Loslegen",
  "signup.mail.label": "Email",
  "signup.name.label": "Name",
  "signup.tradingName.label": "Handelsname (optional)",
  "signup.phone.label": "Tel.",
  "signup.password.label": "Passwort",
  "signup.size.label": "Größe in ha",
  "signup.farmType.label": "Farm Typ",
  "signup.TandC":
    "Indem du dich registrierst, erklärst du dich mit unseren <a>Datenschutz Bestimmungen</a> einverstanden.",
  "signup.farmType.beef": "Rinder",
  "signup.farmType.beef_sheep": "Rinder & Schaafe",
  "signup.farmType.sheep": "Schaaf",
  "signup.farmType.dairy": "Milchkühe",
  "signup.farmType.other": "Sonstiges",
  "signup.cbInterest.label": "Interesse am Carbon Farming",
  "signup.cbInterest.yes": "Ja",
  "signup.cbInterest.no": "Nein",
  "signup.welcome.enterFields.title": "Felder eingeben",
  "signup.welcome.title": "Willkommen",
  "signup.welcome.text":
    "Hier finden Sie einige Tipps für den Anfang. Wenn Sie Fragen haben, können Sie sich jederzeit an uns wenden",
  "signup.welcome.link": "Kontakt zum Support",
  "signup.welcome.enterFields.text":
    "Mit wenigen Klicks können Sie Felder direkt auf der Karte einzeichnen. Wir berechnen die Grasbedeckung innerhalb von Sekunden, damit Sie sie sehen können. Wenn Sie einen großen Betrieb haben, können Sie uns eine Datei mit Ihren Feldgrenzen schicken und wir laden sie für Sie hoch.",
  "signup.welcome.enterAnimalGroups.title": "Tiergruppen eingeben",
  "signup.welcome.enterAnimalGroups.text":
    "Wir erkennen das Grasangebot aus dem Weltraum, aber wir brauchen Ihre Hilfe für den zweiten Teil der Gleichung: die Nachfrage nach Tieren. Legen Sie Tiergruppen mit so vielen Tierklassen an, wie Sie möchten. Wenn Sie Ratschläge wünschen, wie Sie den genauen Bedarf pro Tier ermitteln können, nehmen Sie einfach Kontakt mit uns auf.",
  "signup.welcome.planRotations.title": "Planen Sie Ihre Rotationen",
  "signup.welcome.planRotations.text":
    "Sobald Sie die Felder und Tiergruppen eingerichtet haben, können Sie Ihre Tiere bewegen und Ihre Umtriebe mithilfe des Graskeils planen. Ordnen Sie Felder zu oder nicht, ändern Sie die Rotationslänge und das Weideziel. Die blaue Bedarfslinie zeigt Ihnen, wo Sie Überschüsse oder Defizite haben.",
  "edit.editingField": "Weide Bearbeiten",
  "edit.addingField": "Neue Weide Hinzufügen",
  "edit.editingAnimalGroup": "Tiergruppe Bearbeiten",
  "edit.addingAnimalGroup": "Neue Tiergruppe Hinzufügen",
  "edit.fieldname.label": "Weidename",
  "edit.animalGroupName.label": "Name der Tiergruppe",
  "edit.stockClassName.label":
    "Tier Typ (neue hinzufügen oder Vorlage verwenden)",
  "edit.stockClassName.feedBudgetPlanner.label": "Tiername",
  "edit.stockClassNrOfAnimals.label": "Tieranzahl",
  "edit.stockClassAvgWeight.label": "Durchschnittliches Gewicht",
  "edit.minNumber.error": "Muss mindestens {min} sein",
  "edit.maxNumber.error": "Muss kleiner oder gleich {max} sein",
  "edit.required.error": "Dieses Feld ist erforderlich",
  "edit.number.error": "Dieses Feld muss eine Zahl sein",
  "edit.stockClassFeedType.label": "Fütterung (z.B. 'Trocken - Wartung')",
  "edit.stockClassDemand.label": "Täglicher Futterbedarf",
  "edit.stockClassDefaultStockClass.label": "Art der Tierklasse",
  "edit.weight.label": "Gruppengewicht",
  "edit.demand.label": "Futterbedarf",
  "edit.button.cancel": "Abbrechen",
  "edit.button.save": "Speichern",
  "edit.button.edit": "Bearbeiten",
  "edit.button.back": "Zurück",
  "edit.button.next": "Weiter",
  "edit.button.confirm": "Bestätigen",
  "map.drawfield.drawTools.aria": "Zeichnungswerkzeuge",
  "map.drawfield.tooltip": "Äußere Bezäunung zeichnen oder bearbeiten",
  "map.drawfield.help.tooltip": "Zeichnungshilfe",

  "map.drawfield.help.modal.title": "Feldeditor-Hilfe",
  "map.drawfield.help.modal.welcome":
    "Willkommen im ruumi-Feldeditor! Hier finden Sie einige Tipps, um mit dem Zeichnen von Feldern zu beginnen. Wenn Sie Fragen haben, können Sie sich jederzeit an uns wenden",
  "map.drawfield.help.modal.link": "Kontakt zum Support",
  "map.drawfield.help.modal.createMode.title":
    "Erstellen einer neuen Feldgrenze",
  "map.drawfield.help.modal.createMode.description":
    'Wenn noch keine Feldgrenze vorhanden ist (oder nachdem sie gelöscht wurde), drücken Sie die Schaltfläche <pencilButton></pencilButton>, um in den Modus "Erstellen" zu wechseln. Erstellen Sie dann die neue Feldgrenze, indem Sie auf die Ränder Ihres Feldes in der Karte klicken. Die Feldgrenze wird nach Ihren Klicks gezeichnet.',
  "map.drawfield.help.modal.createMode.zoomControls.description":
    "Verwenden Sie die <navIcon></navIcon>-Schaltflächen zum Vergrößern und Verkleinern für mehr Präzision.",
  "map.drawfield.help.modal.createMode.undo.description":
    'Wenn Sie auf die falsche Stelle geklickt haben, können Sie dies mit der Schaltfläche <undoButton></undoButton> rückgängig machen. Es ist nicht möglich, die Feldbegrenzung im Modus "Erstellen" zu ändern, sondern nur schrittweise rückgängig zu machen.',
  "map.drawfield.help.modal.createMode.boundaryCorrectness.description":
    'Bitte beachten Sie, dass die Feldbegrenzung eine konvexe Form mit mindestens 3 Punkten sein muss, um gespeichert zu werden. Wenn die Begrenzung korrekt ist, werden die Fläche und die Begrenzung sichtbar und die Schaltfläche "SPEICHERN" ist aktiv.',
  "map.drawfield.help.modal.createMode.finish.description":
    'Wenn Sie mit dem Zeichnen fertig sind, klicken Sie entweder auf den <pencilButton></pencilButton> oder drücken Sie "Enter", um den Modus "Erstellen" zu verlassen. Dann können Sie das Feld speichern.',
  "map.drawfield.help.modal.editMode.title":
    "Bearbeitung der bestehenden Feldgrenze",
  "map.drawfield.help.modal.editMode.description":
    'Wenn die Feldgrenze bereits vorhanden ist, wechseln Sie in den Modus "Bearbeiten", indem Sie die Schaltfläche <pencilButton></pencilButton> drücken.',
  "map.drawfield.help.modal.editMode.move.description":
    "Verschieben Sie vorhandene Punkte durch Klicken und Ziehen: <movePointImg></movePointImg>. Fügen Sie neue Punkte hinzu, indem Sie auf die Feldbegrenzung (rote Linien) klicken.",
  "map.drawfield.help.modal.editMode.select.description":
    'Doppelklicken Sie auf die Punkte, um sie auszuwählen. Die ausgewählten Punkte werden rot: <selectPointImg></selectPointImg>. Löschen Sie ausgewählte Punkte mit der Schaltfläche <deleteButton></deleteButton> oder drücken Sie die Taste "Delete". Es können mehrere Punkte auf einmal ausgewählt und gelöscht werden. Doppelklicken Sie erneut auf den ausgewählten Punkt, um die Auswahl aufzuheben.',
  "map.drawfield.help.modal.editMode.finish.description":
    'Wenn Sie mit der Bearbeitung fertig sind, klicken Sie entweder auf die <pencilButton></pencilButton> oder drücken Sie "Enter", um den Modus "Bearbeiten" zu verlassen. Dann können Sie das Feld speichern.',
  "map.drawfield.help.modal.deleteBoundary.title":
    "Löschen der gesamten Feldbegrenzung",
  "map.drawfield.help.modal.deleteBoundary.description":
    'Manchmal kann es erforderlich sein, die Feldbegrenzung von Grund auf neu zu zeichnen. Wenn Sie sich nicht im Modus "Erstellen" oder "Bearbeiten" befinden, verwenden Sie den <deleteButton></deleteButton>, um die gesamte Feldbegrenzung zu löschen. Wechseln Sie dann in den Modus "Erstellen" und zeichnen Sie die neue Begrenzung.',
  "map.drawfield.help.modal.close": "Schließen",
  "map.deletefeature.tooltip":
    "Ausgewähltes Feature löschen (auch mit Tastaturtaste Delete)",
  "map.deleteTentativePosition.tooltip":
    "Vorherigen Punkt löschen (auch mit Tastaturtaste Delete)",
  "map.deleteSelectedHandles.tooltip": "Löschen der ausgewählten Punkte",
  "map.clickOnPencilButton.hint":
    "Drücken Sie die Taste ✏️ und klicken Sie dann auf die Karte, um das Feld zu zeichnen.",
  "map.clickOnPencilButtonToEdit.hint":
    "Drücken Sie die Taste ✏️, um das Feld zu bearbeiten oder zu löschen.",
  "map.provideThreePoints.hint":
    "Bitte fügen Sie mindestens 3 Punkte hinzu, um eine konvexe Feldbegrenzung zu erstellen.",
  "map.provideValidGeometry.hint":
    "Die Feldgeometrie ist ungültig, bitte erstellen Sie eine konvexe Feldbegrenzung mit mindestens 3 Punkten.",
  "map.doubleClickToFinish.hint":
    "Klicken Sie auf den letzten Punkt oder auf die Schaltfläche ✏️, um das Zeichnen zu beenden.",
  "map.editingField.hint":
    "VVerschieben Sie die Punkte oder klicken Sie auf die Begrenzung, um eine neue hinzuzufügen, klicken Sie auf die Punkte, um sie auszuwählen. Drücken Sie zum Beenden erneut die Schaltfläche ✏️.",
  "map.deleteHandles.hint":
    "Klicken Sie erneut auf die ausgewählten Punkte, um die Auswahl aufzuheben.",
  "map.unableDeleteHandles.hint":
    "Es ist nicht möglich, ausgewählte Punkte zu entfernen, da die Feldgrenze nach dem Entfernen mindestens 3 Punkte haben muss, bitte deaktivieren Sie einige",
  "map.deletefeature.confirmation.title": "Feld löschen",
  "map.deletefeature.confirmation.description":
    "Die gesamte Feldgrenze wird entfernt, wollen Sie fortfahren?",
  "map.deletefeature.confirmation.confirm.label": "Löschen",
  "map.deletefeature.confirmation.cancel.label": "Weiter bearbeiten",
  "menu.paddocks.label": "Weiden (Vorschau)",
  "menu.herds.label": "Herden (Vorschau)",
  "menu.history.label": "Protokolle (Vorschau)",
  "warning.tooltip.title": "Überweidet!",
  "fieldinput.area.text": "Größe",
  "fieldinput.area.unit": "ha",
  "fieldinput.na": "N/A",
  "fieldinput.boundary.error": "Ungültige Weidenbegrenzung",
  "fieldinput.save.error": "Speichern nicht möglich",
  "fieldinput.assignedTo.silage": "Silage",
  "fieldinput.assignedTo.text": "Zugeordnet zu",
  "fieldinput.grassType.notsetyet": "N/A",
  "fieldinput.grassType.text": "Weidezusammensetzung",
  "fieldinput.grassType.option.PERMANENT_PASTURE": "Dauerweide",
  "fieldinput.grassType.option.HERBAL_LEY": "Weidekräuter",
  "fieldinput.grassType.option.RYE_GRASS": "Weidelgrass",
  "fieldinput.grassType.option.RYE_GRASS_AND_CLOVER": "Weidelgrass mit Kree",
  "fieldinput.grassType.option.WILDFLOWER_MEADOW": "Wildblumen",
  "fieldinput.grassType.option.LUCERNE_SAINFOIN": "Lucerne und Esparsetten",
  "fieldinput.grassType.option.BRASSICAS": "Kohl",
  "fieldinput.grassType.option.OTHER": "Andere",
  "fieldinput.arableType.option.WHEAT": "Weizen",
  "fieldinput.arableType.option.BARLEY": "Gerste",
  "fieldinput.arableType.option.OILSEED_RAPE": "Ölraps",
  "fieldinput.arableType.option.POTATO": "Kartoffeln",
  "fieldinput.arableType.option.MAIZ": "Mais",
  "fieldinput.arableType.option.CEREALS": "Getreide",
  "fieldinput.arableType.option.VEGETABLES_SALAD": "Gemüse und Salat",
  "fieldinput.arableType.option.OTHERS": "Andere",
  "fieldinput.fieldType.option.ARABLE": "Acker",
  "fieldinput.fieldType.option.GRASS": "Gras",
  "fieldinput.fieldType.text": "Art des Feldes",
  "fieldinput.arableType.text": "Art des Ackers",
  "fieldList.arable.fields": "Äcker",
  "fieldlist.emptyArable": "Keine Äcker",
  " fieldinput.arableType.notsetyet": "Bitte wählen",
  "fieldinput.title.mobile": "Details eingeben",
  "fieldinput.addField.instructions":
    "Klick auf ✏️ oben, dann klick auf der Karte um die Weidebegrenzung zu zeichnen. Doppelklicken Sie auf die Feldbegrenzung, um das Zeichnen zu beenden.",
  "fieldview.area.text": "Größe",
  "fieldview.area.unit": "ha",
  "fieldview.perimeter.text": "Außenumfang",
  "fieldview.perimeter.unit": "m",
  "fieldview.availableDryMatter.text": "Verfügbare Trockenmasse",
  "fieldview.availableDryMatter.unit": "kgTM",
  "fieldview.grazingDaysAhead.text": "Weidetage verfügbar",
  "fieldview.grazingDaysAhead.unit": "{days}d {hours}h",
  "fieldview.growth.text": "Wachstumsrate",
  "fieldview.growth.unit": "kgTM/ha/Tag",
  "fieldview.totalCover.text": "TM Dichte",
  "fieldview.totalCover.unit": "kgTM/ha",
  "fieldview.notfound": "404 - Not Found!",
  "fieldview.overgrazed": "überweidet",
  "fieldview.noDryMatterNow.text": "(am berechnen)",
  "fieldview.fieldUpdate.success": "Weide erfolgreich gespeichert",
  "fieldview.fieldUpdate.error": "Weide konnte nicht gespeichert werden",
  "fieldview.lastUpdated": "Aktualisiert",
  "fieldview.assignedto.text": "Zugeordnet zu",
  "fieldview.moveAnimals.text": "Tiere bewegen",
  "fieldview.animalsOnThisField.text": "Tiere sind auf diesem Feld",
  "popover.availableDM.unit": "kgTM",
  "popover.availableDM.short": "verf.",
  "popover.noDryMatterNow.text": "(am berechnen)",
  "fieldlist.dryMatterNow.unit": "kgTM/ha",
  "fieldlist.noDryMatterNow.text": "(am berechnen)",
  "fieldlist.empty": "Keine Felder zugeordnet",
  "fieldlist.emptySilage": "Keine Felder in der Silage",
  "fieldevents.silage.title": "Gemäht für Silage",
  "fieldevents.silage.dates": "Mähdatum: {dateCut}",
  "fieldevents.grazed.title": "Geweidet",
  "fieldevents.moveIn.title": "Eingezogen",
  "fieldevents.moveOut.title": "Ausgezogen",
  "fieldevents.grazed.dateIn": "Start: {dateIn}",
  "fieldevents.grazed.dateOut": "End: {dateOut}",
  "fieldevents.event.preCover": "Bestand bevor: {preCover} kgTM/ha",
  "fieldevents.event.postCover": "Betand danach: {postCover} kgTM/ha",
  "fieldevents.reading.title": "Betand aktualisiert",
  "fieldevents.reading.value": "Neuer Betands: {value} kgTM/ha",
  "fieldevents.reading.date": "Aktualisiert am: {date}",
  "fieldevents.list.title": "Aktivitäten",
  "fieldevents.menu.edit": "Bearbeiten",
  "fieldevents.menu.accept": "Akzeptieren",
  "fieldevents.menu.reject": "Verwerfen",
  "fieldevents.menu.delete": "Löschen",
  "fieldevents.notify.deleted": "Event gelöscht",
  "fieldevents.notify.accepted": "Automatisch erkanntes Event akzepiert",
  "fieldevents.notify.rejected": "Automatisch erkanntes Event verworfen",
  "fieldevent.autodetected.tooltip": "Automatisch erkanntes Event",
  "fieldevent.manualinput.tooltip": "Event von dir eingeben",
  "farm.growth.label": "Wachstumsrate",
  "farm.growth.unit": "kgTM/ha/day",
  "farm.totalDM.label": "Durchschnittliche TM Dichte",
  "farm.totalDM.unit": "kgTM/ha",
  "farm.availableDM.label": "Verfügbares Futter",
  "farm.availableDM.unit": "t TM",
  "farm.metrics.title": "Hofmetriken",
  "farm.animals": "Tiere",
  "farm.totalArea": "Gesamtfläche",
  "farm.fields": "Felder",
  "farm.title": "Hof",
  "farm.prefix": "Hof",
  "field.prefix": "Feld",
  "animalGroup.prefix": "Gruppe",
  "farm.menu.edit": "Hof bearbeiten",
  "farm.menu.delete": "Hof löschen",
  "farm.edit.title": "Hof bearbeiten",
  "farm.edit.nameLabel": "Hofbezeichnung",
  "farm.edit.locationLabel": "Standort des Hofes",
  "farm.edit.locationHint":
    "Verschieben und zoomen Sie die Karte, um die Hofgrenze anzupassen",
  "farm.edit.success": "Hof erfolgreich aktualisiert",
  "farm.delete.success": "Hof erfolgreich gelöscht",
  "farm.delete.inProgress": "Hof wird gelöscht...",
  "farm.delete.notOwner": "Nur der Eigentümer kann diesen Hof löschen",
  "farm.delete.selectFarm.title": "Hof auswählen",
  "farm.delete.selectFarm.description":
    'Der Hof "{name}" wird gelöscht. Bitte wählen Sie den Hof, zu dem Sie wechseln möchten:',
  "confirmationdeletedialog.farm.title": "Hof löschen",
  "confirmationdeletedialog.farm.description":
    'Sind Sie sicher, dass Sie "{name}" löschen möchten? Dadurch werden alle Felder, Tiergruppen und Daten dieses Hofes dauerhaft gelöscht.',
  "farm.addMenu.field": "Feld hinzufügen",
  "farm.addMenu.cover": "Messwert hinzufügen",
  "farm.addMenu.addGrassTypes": "Grassorten angeben",
  "farm.addMenu.animalGroup": "Tiergruppe hinzufügen",
  "farm.add.addName.mobile": "Hofbezeichnung eingeben",
  "farm.add.addName.desktop": "Gib die Bezeichnung des Hofes ein",
  "farm.add.saveLocation.desktop": "Finde den Standort auf der Karte ",
  "farm.add.saveFarm.desktop": ", dann clicke speichern.",
  "farm.add.saveLocation.mobile": "Standort Speichern",
  "farm.add.addName.error": "Bitte Bezeichnung eingeben",
  "farm.add.locationInstructions":
    "Zoome zum Standort deines Hofes oder verwenden Sie die Postleitzahlensuche am oberen Rand, dann clicke speichern.",
  "addCovers.next.label": "Weiter",
  "addCovers.back.label": "Zurück",
  "addCovers.cancel.label": "Abbrechen",
  "addCovers.save.label": "Speichern",
  "addCovers.enterTime.heading": "Zeit Eingeben",
  "addCovers.enterTime.subheading": "Wann hast du gemessen?",
  "addCovers.enterTime.dateLabel": "Datum",
  "addCovers.enterTime.startTimeLabel": "Startzeit",
  "addCovers.enterTime.endTimeLabel": "Endzeit",
  "addCovers.enterTime.invalidFinishTime": "Endzeit muss nach Startzeit sein.",
  "addCovers.enterCovers.heading": "Messewerte Eingeben",
  "addCovers.enterCovers.subheading": "Bitte gib deine Messwerte ein.",
  "addCovers.enterCovers.fieldName": "Weide",
  "addCovers.enterCovers.current": "Momentan",
  "addCovers.enterCovers.new": "Messwert",
  "addNewEvent.button": "Ereignis hinzufügen",
  "addNewEvent.type.seeding": "Aussaat",
  "addNewEvent.type.fertilizer": "Düngung",
  "addNewEvent.type.harvest": "Ernte",
  "addNewEvent.type.measurement": "Messung",
  "addNewEvent.type.feeding": "Fütterung",
  "addNewEvent.type.purchase": "Einkauf",
  "addCovers.singleEvent.title": "Ereignis Eingeben",
  "addCovers.singleEvent.tooltip": "Ereignis Eingeben",
  "addCovers.single.unit": "kgTM/ha",
  "addCovers.single.measurementDatetime": "Messzeit",
  "addCovers.single.newCover": "Messwert",
  "addCovers.enterReasons.heading": "Ereignis",
  "addCovers.enterReasons.subheading":
    "Wir haben wohl nicht Alles gesehen. Was haben wir verpasst?",
  "addCovers.enterReasons.fieldName": "Weide",
  "addCovers.enterReasons.difference": "Abweichung",
  "addCovers.enterReasons.reason": "Grund",
  "addCovers.enterReasons.menu.grazed": "Beweidet",
  "addCovers.enterReasons.menu.partGrazed": "Am Weiden",
  "addCovers.enterReasons.menu.silage": "Silage",
  "addCovers.enterReasons.menu.noEvent": "Kein Ereignis",
  "addCovers.eventInput.preCover.Label": "TM Davor",
  "addCovers.eventInput.postCover.Label": "TM Danach",
  "addCovers.eventInput.postCover.Error":
    "TM nach Ereignis muss niedriger sein als vorher.",
  "addCovers.eventInput.dateCut.Label": "Mähdatum",
  "addCovers.eventInput.dateIn.Label": "Weidestart",
  "addCovers.eventInput.dateOut.Label": "Weideende",
  "addCovers.eventInput.dateOut.Error": "Weideende muss nach Weidestart sein.",
  "addCovers.confirmCovers.heading": "Bestätigen und Speichern",
  "addCovers.confirmCovers.noData":
    "Keine Daten eingegeben. Gehe zurück um Daten einzugeben.",
  "addCovers.confirmCovers.accuracy":
    "Unserer Messungen waren innerhalb von {threshold} kg TM/ha von den Messewerten die du eingegeben hast.",
  "addCovers.confirmCovers.datetime":
    "Deine Messwerte vom {readingsDate} von {startTime} - {endTime} werden gespeichert.",
  "addCovers.confirmCovers.infoMessage":
    "Die Karte und Grasswedge werden angepasst.",
  "addCovers.dialog.title": "Messung",
  "addCovers.success": "Messwerte erfolgreich gespeichert.",
  "addCovers.failure": "Messwerte speichern war nicht erfolgreich.",

  "confirmCovers.thumbsUp.tooltip":
    "Messwert sieht gut aus - klick um zu bestätigen",
  "confirmCovers.thumbsUp.alreadyGiven":
    "Sie haben diesen Messwert heute bereits bestätigt",
  "confirmCovers.thumbsUp.title": "Messwert sieht gut aus!",
  "confirmCovers.thumbsUp.text":
    "<p>Das bedeutet, dass der Messwerte genau genug ist, um eine Entscheidung zum Weidemanagement zu treffen.</p><p>Bitte bestätigen Sie den Messwert, damit wir daraus lernen können.</p>",
  "confirmCovers.thumbsUp.cancel": "Abbrechen",
  "confirmCovers.thumbsUp.save": "Bestätigen",
  "confirmCovers.thumbsUp.thankYou.title": "Danke für Ihr Feedback!",
  "confirmCovers.thumbsUp.thankYou.text":
    "Ihre Rückmeldung hilft uns, die Messwerte für alle zu verbessern.",
  "confirmCovers.thumbsUp.thankYou.close": "Super!",

  "confirmCovers.thumbsDown.tooltip":
    "Messwert ist ungenau - klick um zu zu korrigieren",
  "confirmCovers.thumbsDown.alreadyGiven":
    "Sie haben den Messwert heute bereits aktualisiert",
  "confirmCovers.thumbsDown.title": "Messwert ist ungenau!",
  "confirmCovers.thumbsDown.text":
    "<p>Das bedeutet, dass der Messwert nicht genau genug ist, um eine Entscheidung über das Weidemanagement zu treffen.</p><p>Bitte geben Sie den Messwert ein, damit wir zukünftige Messwerte besser schätzen können.</p>",
  "confirmCovers.thumbsDown.cancel": "Abbrechen",
  "confirmCovers.thumbsDown.save": "Bestätigen",
  "confirmCovers.thumbsDown.thankYou.title": "Danke für Ihr Feedback!",
  "confirmCovers.thumbsDown.thankYou.text":
    "Ihre Rückmeldung hilft uns, die Messwerte für alle zu verbessern.",
  "confirmCovers.thumbsDown.thankYou.close": "Super!",

  "reseedEvent.heading": "Neu Sähen",
  "addDate.enterTime.dateLabel": "Datum",
  "reseedEvents.selectFields.text": "Feld(er)",
  "reseedEvent.grassType.text": "Neue Grasart",
  "reseedEvent.grassType.placeholder": "Grasart wählen",
  "reseedEvent.seedingMethod.placeholder": "Methode wählen",
  "reseedEvent.notes.label": "Notizen",
  "reseedEvents.show.title": "Neu gesäht",
  "reseedEvents.show.titleName": "Neu gesäht {name}",
  "reseedEvent.reseedDate": "Datum: {reseedDate}",
  "reseedEvent.newGrassType": "Grassart: {newGrassType}",
  "editReseedEvent.heading": "Neusaat editieren",
  "editReseedEvent.field.heading": "Feldname",
  "viewReseedEvent.heading": "Nachsaatereignis anzeigen",
  "editReseedEvent.success": "Neusaat erfolgreich editiert",
  "farm.addMenu.addReseedEvent": "Neuansaaten hinzufügen",
  "addGrassType.save.label": "Speichern",
  "addGrassType.cancel.label": "Abbrechen",
  "addGrassType.enterGrassType.heading": "Grasssorten angeben",
  "addGrassType.enterGrassType.subheading":
    "Bitte wählen sie die Grassorten für Felder bei denen das noch nicht geschehen ist.",
  "addGrassType.enterGrassType.tableHeading": "Grasssorten angeben",
  "addGrassType.enterGrassType.fieldName": "Feld",
  "addGrassType.enterGrassType.selection": "Grasssorten",
  "updateGrassTypes.success": "Grasssortenänderung erfolgreich",
  "fieldlistmenu.silage.label": "Verschiebe zu Silage",
  "fieldlistmenu.animalGroup.label": "Verschiebe zu {group}",
  "fieldlistmenu.edit.label": "Weide Bearbeiten",
  "fieldlistmenu.delete.label": "Weide Löschen",
  "fieldlistmenu.moveIn.label": "Tiere auf das Feld bewegen",
  "fieldlistmenu.moveIn.tooltip.silage":
    "Sie können keine Tiere auf ein Silofeld verschieben. Wir behandeln Felder, die keiner Tiergruppe zugeordnet sind, als Silofelder.",
  "fieldlistmenu.moveIn.tooltip.sameField":
    'Um Ihre Tiere in ein anderes Feld zu verschieben, wählen Sie das Feld, in das Sie die Tiere verschieben möchten, und klicken Sie auf "Tiere hierher verschieben"',
  "confirmdeletedialog.cancel.label": "Abbrechen",
  "confirmdeletedialog.confirm.label": "Löschen",
  "confirmationdeletedialog.animalGroup.title": "Tiergruppe löschen",
  "confirmationdeletedialog.animalGroup.description":
    'Bist du dir sicher, dass du "{name}" löschen willst?',
  "confirmDeleteFieldDialog.text":
    "Du willst {fieldName} löschen. Bist du dir sicher?",
  "confirmDeleteFieldDialog.title": "Weide Löschen",
  "confirmcanceldialog.cancel.label": "Weiter bearbeiten",
  "confirmcanceldialog.confirm.label": "Veränderungen verwerfen",
  "confirmcanceldialog.text":
    "Wenn du jetzt abbrichst, verlierst du alle Veränderungen. Bist du dir sicher?",
  "confirmcanceldialog.title": "Veränderungen Verwerfen",
  "toolbar.farmview.title": "Farm",
  "toolbar.fieldview.title": "Weidendetails",
  "toolbar.grasstype-reseeding.title": "Rasentyp und Nachsaat",
  "map.cursorTooltip.unit": "kgTM/ha",
  "hint.welcome.title": "Willkommen ",
  "hint.welcome.text": "Klicke auf + um deine erste Weide anzulegen",
  "hint.animalGroups.title": "Tiergruppe Hinzufügen ",
  "hint.animalGroups.text": "Klicke auf + um deine erste Gruppe anzulegen",
  "animalGroup.menu.edit": "Tiergruppe bearbeiten",
  "animalGroup.menu.delete": "Tiergruppe löschen",
  "animalGroup.groupWeight": "Gesamtgewicht der Tiergruppe",
  "animalGroup.groupDemand": "Bedarf",
  "animalGroup.noFieldsAssigned": "Noch keine Felder hinzugefügt",
  "animalGroup.demandUnit": "{demandPerHaAndDay} kgTM/ha/Tag",
  "animalGroup.animalCount": "Anzahl Tiere in Tiergruppe",
  "animalGroupInput.boundary.error": "Etwas ist fehlgeschlagen",
  "animalGroupInput.addStockClass": "eine weitere Tierklasse hinzufügen",
  "animalGroupInput.demand":
    "{groupDemandInKg} kgTM ({groupDemandInPercent}%) pro Tag",
  "animalGroupInput.stockClasses": "Tierklasses",
  "animalGroupInput.stockClasses.birthingPeriods": "Ablammen/Kalben Details",
  "animalGroupInput.stockClasses.birthingPeriods.dateStart": "Beginn",
  "animalGroupInput.stockClasses.birthingPeriods.dateEnd": "Ende",
  "animalGroupInput.stockClasses.birthingPeriods.expectedNumAnimalsWithoutPregnancy":
    "Anzahl der nicht trächtigen Tiere ",
  "animalGroupInput.stockClasses.birthingPeriods.expectedNumOffspringPerAnimal":
    "Erwartete Anzahl von Kälbern/Lämmern pro Tier",
  "animalGroups.overview.demand": "Bedarf: {demand} kgTM/ha/Tag",
  "animalGroups.overview.availableDryMatter":
    "Verfügbare Trockenmasse: {availableDryMatter} kgTM",
  "animalGroups.overview.averageCover": "TM Dichte: {averageCover} kgTM/ha",
  "toolbar.animalGroupView.title": "Tiergruppe",
  "silage.title": "Silage",
  "silage.description": "TM Dichte: {averageCover} kgTM/ha",
  "grassWedge.open": "Grass Wedge Öffnen",
  "units.kilogramPerHectar": "kgTM/ha",
  "units.days": "Tage",
  "grassWedge.postGrazingTarget": "Nachweide Ziel",
  "grassWedge.preGrazingTarget": "Berechnetes Vorweide Ziel",
  "grassWedge.rotationLength": "Rotationsdauer",
  "grassWedge.averageCover": "Durchschnittliche Trockenmasse KgTM/Ha",
  "grassWedge.demand": "Bedarf KgTM/ha/Tag",
  "grassWedge.growth": "Wachstumsrate kgDT/ha/Tag",
  "grassWedge.grazingDaysAhead": "Weidetage voraus",
  "grassWedge.tooltip.area": "Fläche: {area} {unit}",
  "grassWedge.tooltip.availableDM":
    "Durchschnittliche Trockenmasse: {dm} kgTM/ha",
  "grassWedge.tooltip.grazindDaysAhead":
    "Weidetage verfügbar: {days}d {hours}h",
  "grassWedge.noFields.prompt":
    "Weisen Sie mindestens zwei Felder für die Nutzung des Grass Wedge zu",
  "grassWedge.singleField.prompt":
    "Weisen Sie ein anderes Feld zu, um die Grass Wedge zu nutzen",
  "fieldlistmenu.notification.movedAnimalGroup":
    "{fieldName} wurde zu {animalGroupName} zugeordnet",
  "fieldlistmenu.notification.movedToSilage":
    "{fieldName} wurde zur Silage zugeordnet",
  "fieldlistmenu.notification.moveFailed":
    "{fieldName} konnte nicht zugeordnet werden",
  "fieldlistmenu.notification.editFailed":
    "{fieldName} konnte nicht bearbeitet werden",
  "fieldlistmenu.notification.moveInFailed":
    "Tiere konnten nicht aufs {fieldName} gebracht werden",
  "fieldlistmenu.notification.moveInSuccess":
    "Es wurden Tiere nach {Feldname} gebracht",
  "grassWedge.assignField": "Feld zuordnen",
  "grassWedge.settings": "Einstellungen",
  "grassWedge.title": "Futterkeil",
  "grassWedge.legend.dryMatter": "Trockenmasse",
  "grassWedge.legend.demandLine": "Bedarfs-Ziellinie",
  "grassWedge.legend.demandLineTooltip":
    "Zeigt die ideale Grasbedeckung an jeder Position in der Weiderotation basierend auf Ihren Einstellungen",
  "animalGroup.assignField": "Feld zuweisen",
  "animalGroup.viewFeedAllocation": "Futtermittelzuweisung anzeigen",
  "animalGroup.viewRotations": "Rotationen anzeigen",
  "rotationTimeline.title": "Rotationszeitlinie",
  "rotationTimeline.current": "Aktuell",
  "rotationTimeline.shed": "Stall",
  "rotationTimeline.move": "Umzug #{number}",
  "rotationTimeline.empty": "Noch keine Umzüge erfasst",
  "rotationTimeline.fieldDeleted": "- (Feld gelöscht)",
  "rotationGrid.season": "Saison",
  "rotationGrid.rotation": "Rotation {number}",
  "rotationGrid.status.accepted": "Akzeptiert",
  "rotationGrid.status.proposed": "Vorgeschlagen",
  "rotationGrid.origin.farmer": "Benutzereingabe",
  "rotationGrid.origin.satellite": "Satellit erkannt",
  "rotationGrid.accept": "Akzeptieren",
  "rotationGrid.reject": "Ablehnen",
  "rotationGrid.delete": "Löschen",
  "rotationGrid.preCover": "Deckung vor Beweidung",
  "rotationGrid.postCover": "Deckung nach Beweidung",
  "rotationGrid.notAssigned": "derzeit nicht zugewiesen",
  "rotationGrid.assignedTo": "Derzeit zugewiesen an {name}",
  "rotationGrid.assignedFields": "Derzeit zugewiesen",
  "rotationGrid.otherFields": "Andere Felder",
  "rotationGrid.shed": "In den Stall",
  "rotationGrid.dateOrderError":
    "Enddatum muss am oder nach dem Startdatum liegen",
  "rotationGrid.attach": "Dieser Gruppe zuordnen",
  "rotationGrid.editTime": "Uhrzeit bearbeiten",
  "rotationGrid.hideTime": "Uhrzeit ausblenden",
  "rotationGrid.unattachedTitle": "Warum ist dieses Ereignis nicht zugeordnet?",
  "rotationGrid.unattachedExplanation":
    "Die Zuordnung von Tiergruppen zu einzelnen Beweidungsereignissen wurde im Mai 2024 eingeführt. Ältere Ereignisse haben diese Verknüpfung daher nicht. Wenn diese Gruppe hier geweidet hat, ordne das Ereignis zu, um es in die Rotation aufzunehmen.",
  "rotationGrid.days": "Tage",
  "rotationGrid.flaggedTooltip":
    "Dieses Ereignis scheint ungewöhnlich lang — prüfen Sie, ob die Tiere tatsächlich umgestellt wurden",
  "rotationGrid.flaggedWarning":
    "Ungewöhnlich lange Beweidung — möglicher vergessener Umzug oder Datenfehler",
  "rotationGrid.flaggedSuggestion":
    "Erwägen Sie, dieses Ereignis um {suggestedEnd} zu beenden (~{days} Tage sind üblich)",
  "rotationGrid.addEventHint": "Kein Beweidungsereignis erfasst. Hinzufügen?",
  "rotationGrid.suggestedDates": "Vorgeschlagene Daten:",
  "rotationGrid.addSuggested": "Mit vorgeschlagenen Daten hinzufügen",
  "rotationGrid.addEvent": "Beweidungsereignis hinzufügen",
  "rotationGrid.ongoing": "laufend",
  "rotationGrid.warningCrossYear":
    "{field}: Ereignis erstreckt sich über Jahre — Daten prüfen",
  "rotationGrid.useEndDate": "Am {date} beenden",
  "rotationGrid.edit": "Bearbeiten",
  "rotationGrid.duplicateTooltip":
    "{count} überlappende Ereignisse — klicken zum Bereinigen",
  "rotationGrid.duplicateWarning":
    "{count} überlappende Ereignisse für die gleichen Daten",
  "rotationGrid.removeDuplicates": "{count} Duplikat(e) entfernen",
  "rotationGrid.health.title": "Rotationsgesundheit",
  "rotationGrid.health.noClashes": "Keine Zeitkonflikte",
  "rotationGrid.health.clashes": "{count} Zeitkonflikt(e)",
  "rotationGrid.health.avgGrazing": "Ø {days}d pro Feld",
  "rotationGrid.health.recovery": "Ø Erholung: {days}d",
  "rotationGrid.health.recoveryTarget": "Ziel: {days}d",
  "rotationGrid.health.pathCoverage":
    "{count} von {total} Ereignissen passen zur Rotation",
  "rotationGrid.health.outliers": "{count} Ausreißer anzeigen",
  "rotationGrid.conflict.banner":
    "{count} überlappende(s) Ereignis(se) — Tiere können nur auf einem Feld gleichzeitig sein",
  "rotationGrid.conflict.review": "Überprüfen & lösen",
  "rotationGrid.conflict.stepOf": "Konflikt {step} von {total}",
  "rotationGrid.conflict.question":
    "Am {date} wurden Tiere auf zwei Feldern erfasst. Welches ist korrekt?",
  "rotationGrid.conflict.resolved": "Alle Konflikte gelöst!",
  "rotationGrid.conflict.resolvedDetail":
    "Ihre Rotationsübersicht ist jetzt sauber und konsistent.",
  "review.title": "Aufzeichnungen vervollständigen",
  "review.looksRight": "Stimmt",
  "review.notRight": "Stimmt nicht",
  "review.allDone": "Alles erledigt!",
  "review.allDoneDetail": "Ihre Rotationsübersicht ist aktuell.",
  "review.sameDay": "{count} Ereignisse am {date} brauchen Zeitkorrektur",
  "review.applyFix": "Vorgeschlagene Zeiten übernehmen",
  "review.missingFields": "Übersprungen: {fields}{more}",
  "review.addMissing": "{fields}{more} hinzufügen",
  "review.skippedHint": "{count} Feld(er) nicht besucht",
  "review.pickField": "Welches Feld?",
  "review.enterDates": "Wann waren die Tiere hier?",
  "rotationGrid.emptyYear": "Keine Beweidungsdaten für {year}",
  "rotationGrid.emptyYearHint":
    "Bewegen Sie Ihre Tiere zwischen Feldern, um Ihre Rotationshistorie aufzubauen.",
  "rotationGrid.clash.warning":
    "Überschneidung mit {field} um {days} Tag(e) — Tiere können nur auf einem Feld sein",
  "rotationGrid.outlier.tooltip":
    "Passt wahrscheinlich nicht in die Hauptrotation",
  "rotationGrid.outlier.remove": "Ausreißer entfernen",
  "rotationGrid.estimate.days": "~{days}d gesch.",
  "rotationGrid.recovery.label": "Erholung: {days}d",
  "rotationGrid.recovery.insufficient":
    "Erholung zu kurz ({days}d, benötigt {target}d)",
  "rotationGrid.suggested.label": "Vorgeschlagen",
  "rotationGrid.editDateIn": "Beweidungsbeginn",
  "rotationGrid.editDateOut": "Beweidungsende",
  "grassWedge.notification.saved": "Gespeichert",
  "grassWedge.notification.error": "Etwas ist schief gelaufen.",
  "assignFieldDialog.title": "Feld zu dieser Tiergruppe zuordnen",
  "assignFieldDialog.inputLabel": "Feld",
  "assignFieldDialog.nofieldsLabel": "Keine Felder verfügbar",
  "assignFieldDialog.button": "Zuordnen",
  "setCurrentFieldDialog.title": "Aktuelles Feld festlegen",
  "setCurrentFieldDialog.inputLabel":
    "Wählen Sie das Feld, auf dem die Tiere sind",
  "setCurrentFieldDialog.noFieldsLabel":
    "Keine Felder dieser Gruppe zugeordnet",
  "setCurrentFieldDialog.button": "Festlegen",
  "setCurrentFieldDialog.setButton": "Festlegen",
  "animalGroupInput.add.success": "{animalGroupName} hinzugefügt",
  "animalGroupInput.edit.success": "{animalGroupName} aktualisiert",
  "fieldInput.add.success": "{fieldName} hinzugefügt",
  "fieldInput.edit.success": "{fieldName} aktualisiert",
  "farmInput.add.success": "{farmName} hinzugefügt",
  "animalGroup.grassWedgeButton.tooltip":
    "Mindestens zwei Felder mit Trockenmasse werden benötigt",
  "fieldProposedEventsModal.headline": "Neue Events",
  "fieldProposedEventsModal.description":
    "Akzeptieren oder Verwerfen Sie die automatisch erkannten Weide- oder Mähereignisse unten, um Ihre Werte zu aktualisieren.",
  "fieldProposedEventsModal.description1":
    "ruumi erkennt jetzt, wann ein Feld zuletzt beweidet oder gemäht wurde. Dies geschieht mit Hilfe von Satellitenradar, das alle 2-3 Tage vorbeifliegt und die Wolkendecke durchdringt. Im Moment werden die Vorschläge für Weideereignisse zu Ihrem Feldverlauf hinzugefügt, wenn Sie sie annehmen oder ablehnen.",
  "fieldProposedEventsModal.description2":
    "Tippen Sie auf die Schaltfläche 'Häkchen', wenn Sie glauben, dass ruumi korrekt ist, oder auf die Schaltfläche 'Kreuz', wenn nicht. Mit der Schaltfläche 'Bleistift' können Sie Eintritts- und Austrittszeiten sowie Abdeckungen vor und nach dem Weidegang hinzufügen. Verwenden Sie die Schaltfläche 'Plus', um ein neues Ereignis zu dem Feld hinzuzufügen.",
  "fieldProposedEventsModal.description3":
    "Standardmäßig setzt ruumi die Felder nach der Beweidung auf 1500 kg TM/ha zurück oder auf den Restwert, den Sie im Grass Wedge der Gruppe angeben.",
  "fieldProposedEventsModal.description4":
    "Sie können auch erkannte Ereignisse finden, wenn Sie auf ein Feld klicken und in der linken unteren Ecke nachsehen.",
  "fieldProposedEventsModal.close": "Schließen",
  "fieldProposedEventsModal.help": "Hilfe",
  "certificationProgramApplicationModal.headline":
    "ruumi Zertifizierungsprogramm",
  "certificationProgramApplicationModal.description":
    "Durch die Nutzung von ruumi erstellen Sie einen umfangreichen Datensatz über Ihre landwirtschaftlichen Aktivitäten. Wir können diese Daten nutzen, um die hochwertigsten Kohlenstoffgutschriften zu erstellen. Klicken Sie unten, um sich für unser Zertifizierungsprogramm für Kohlenstoffgutschriften zu bewerben.",
  "certificationProgramApplicationModal.cta":
    "Anmeldung für ruumi CO2 Zertifikate",
  "carbon.profile.cta.text":
    "Finden Sie heraus, wie Sie die Umstellung auf regenerative Verfahren finanzieren können - ",
  "carbon.profile.cta.link":
    "<Link>buchen Sie eine kostenlose Beratung</Link>.",
  "after_first_field_created.field.dialog.title": "Glückwunsch!",
  "after_first_field_created.field.dialog.text":
    "Sie koennen jetzt weitere Felder zeichnen oder Tiergruppen hinzufügen und diese den Feldern zuordnen. Dann ist es an der Zeit, die Tiere grasen zu lassen!",
  "after_field_created.field.dialog.text": "Feld wurde angelegt!",
  "after_field_created.field.dialog.close": "Schließen",
  "after_field_created.field.dialog.anotherField": "Noch ein Feld zeichnen",
  "after_field_created.field.dialog.addAnimalGroup": "Tiergruppe hinzufügen",
  "map.postcodeInput.placeholder": "AB10 1AB",
  "map.postcodeInput.helperText": "Zur Postleitzahl des Bauernhofs navigieren",
  "oauth2.redirect.dialog.title": "Weiterleitung",
  "oauth2.redirect.dialog.content":
    "Sie werden nun weitergeleitet zu <a>{url}</a>. ",
  "oauth2.success.dialog.title": "Erfolgreich!",
  "oauth2.success.dialog.content":
    "Sie haben Ihr Konto bei {providerName} erfolgreich mit ruumi verbunden. Wir importieren Farmen, Tiere und Felder.",
  "oauth2.success.dialog.contentSignup":
    "Willkommen bei ruumi! Bitte erzählen Sie uns etwas über Ihren Betrieb, während wir Ihre Daten von {providerName} laden.",
  "oauth2.success.dialog.importing":
    "Importiere Farm {farmName}, {animalGroupsCount} Tiergruppen, {fieldsCount} Felder importiert.",
  "oauth2.error.dialog.title": "Fehler",
  "oauth2.error.dialog.content":
    "Konnte keine Verbindung zum Konto {providerName} herstellen, bitte versuchen Sie es <a>hier</a> erneut. ",
  "settings.agriwebb": "AgriWebb verbunden",
  "settings.agriwebb.remove": "Verbindung entfernen",
  "oauth2ClientRemove.success": "Integration von {providerName} entfernt",
  "newSignup.userDetails.alreadyRegistered":
    "Bereits registriert? <a>Hier anmelden</a>.",
  "passwordForgot.dialog.title": "Passwort vergessen",
  "passwordForgot.mail.label": "E-Mail",
  "passwordForgot.button.label": "Passwort zurücksetzen",
  "passwordForgot.success":
    "Großartige Neuigkeiten! Wir haben Ihnen eine E-Mail mit Anweisungen zum Zurücksetzen Ihres Passworts geschickt. Bitte prüfen Sie Ihren Posteingang.",
  "passwordForgot.success.2":
    "Wenn Sie sie nicht finden können, zögern Sie bitte nicht, uns unter hello@ruumi.io zu kontaktieren, und wir helfen Ihnen gerne weiter.",
  "passwordForgot.failure":
    "Senden der E-Mail an Ihre Adresse nicht möglich. Bitte kontaktieren Sie uns unter hello@ruumi.io.",

  "passwordReset.userDetails.text1": "Legen Sie Ihr neues Passwort fest",
  "passwordReset.userDetails.dialogTitle": "Passwort zurücksetzen",
  "passwordReset.button.label": "Passwort zurücksetzen",
  "passwordChange.failure": "Passwortänderung nicht möglich",

  "defaultStockClass.DAIRY_COW": "Milchkuh",
  "defaultStockClass.DAIRY_COW_2_KGMS": "Milchkuh (2 kgMS)",
  "defaultStockClass.DAIRY_COW_2_KGMS.notes":
    "2kgMS = ~28l @ 7.5% Feststoffe - Spitzenlaktation",
  "defaultStockClass.SUCKLER_COW": "Mutterkuh",
  "defaultStockClass.SUCKLER_COW.notes":
    "inklusive Kalb bis zu einem Alter von 200 Tagen",
  "defaultStockClass.GROWING_CATTLE": "Wachsendes Rind",
  "defaultStockClass.EWE": "Mutterschaf",
  "defaultStockClass.EWE_TWINS": "Mutterschaf (Zwillinge)",
  "defaultStockClass.EWE_TWINS.notes":
    "inklusive Lämmer bis zu einem Alter von 100 Tagen",
  "defaultStockClass.WEANED_LAMB": "Abgesetztes Lamm",

  "defaultFeeding.DRY_MAINTENANCE": "Trocken - Erhaltung",
  "defaultFeeding.THIRTY_DAYS_PRE_CALVING": "30 Tage vor dem Kalben",
  "defaultFeeding.LTE_2_MONTHS_POST_CALVING": "0-2 Monate nach dem Kalben",
  "defaultFeeding.GT_2_MONTHS_POST_CALVING": ">2 Monate nach dem Kalben",
  "defaultFeeding.DRY_MAINTENANCE_BCS_GAIN":
    "Trocken - Erhaltung + BCS Zunahme",
  "defaultFeeding.GTE_3_LTE_4_MONTHS_POST_CALVING":
    "3-4 Monate nach dem Kalben",
  "defaultFeeding.GT_4_MONTHS_POST_CALVING":
    ">4 Monate nach dem Kalben bis zum Absetzen",
  "defaultFeeding.GT_4_MONTHS_POST_CALVING.notes":
    "inklusive Kalb bis zu einem Alter von 200 Tagen",
  "defaultFeeding.MAINTENANCE": "Erhaltung",
  "defaultFeeding.MAINTENANCE_500G_DLWG": "Erhaltung + 0,5 kg DLWG",
  "defaultFeeding.MAINTENANCE_1KG_DLWG": "Erhaltung + 1 kg DLWG",
  "defaultFeeding.MAINTENANCE_GT_1KG_DLWG": "Erhaltung + >1 kg DLWG",
  "defaultFeeding.THIRTY_DAYS_PRE_LAMBING": "30 Tage vor dem Lammern",
  "defaultFeeding.LTE_1_MONTHS_POST_LAMBING": "0-1 Monat nach dem Lammern",
  "defaultFeeding.GT_1_MONTH_POST_LAMBING_TO_WEANING":
    ">1 Monat nach dem Lammern bis zum Absetzen",
  "defaultFeeding.GT_1_MONTH_POST_LAMBING_TO_WEANING.notes":
    "inklusive Lämmer bis zu einem Alter von 100 Tagen",
  "defaultFeeding.MAINTENANCE_50G_DLWG": "Erhaltung + 50 g DLWG",
  "defaultFeeding.MAINTENANCE_150G_DLWG": "Erhaltung + 150 g DLWG",
  "defaultFeeding.MAINTENANCE_GT_150G_DLWG": "Erhaltung + >150 g DLWG",
  "stockClassDemandTemplateAutocomplete.customValue":
    'Verwenden Sie "{inputValue}"',
  "stockClassDemandTemplateAutocomplete.listItemTitle":
    "{stockClassName} — {allocatedBodyWeightFraction}% KGW",
  "common.reloadPage":
    "Die Grazing-App wurde aktualisiert, neue Version wird geladen, bitte warten",
  "moveOut.updateCover": "Bestand auf {name} aktualisieren?",
  "moveOut.fromField": "Von Feld: {fieldName}",
  "moveOut.toField": "Auf Feld: {fieldName}",
  "moveOut.title": "Tiere bewegen sich",
  "moveOut.date.label": "Datum",
  "moveOut.minDateInfo":
    "Diese Tiergruppe wurde zuletzt am {minDate} bewegt. Das gewählte Datum muss danach liegen.",
  "moveOut.subTitle":
    "Bestand auf {fieldName} ändern von {currentCover} kgDM/ha",
  "moveOut.subTitle2": "nach",
  "moveOut.postCover.label": "Neuer Bestand",
  "moveOut.leaveIt.label": "Bestand nicht aktualisieren",
  "moveOut.changeIt.label": "Bestand aktualisieren",
  "moveAnimals.titlePrefix": "Gruppe bewegen:",
  "moveAnimals.date.label": "Wann wurde bewegt?",
  "moveAnimals.from.label": "Wo sind die Tiere jetzt?",
  "moveAnimals.to.label": "Wohin werden sie bewegt?",
  "moveAnimals.postGrazingCover.label": "Bestand nach Beweidung",
  "moveAnimals.preGrazingCover.label": "Bestand vor Beweidung",
  "moveAnimals.useTarget": "Zielwert verwenden ({value})",
  "moveAnimals.cancel": "Abbrechen",
  "moveAnimals.submit": "Tiere bewegen",
  "moveAnimals.noFields": "Keine Felder verfügbar",
  "farmView.button.grasstype-reseeding.title": "Rasentyp und Nachsaat",
  "reseedingDetailView.button.addReseedingEvent.title":
    "Neues Nachsaatereignis hinzufügen",
  "reseedingDetailView.button.updateGrassTypes.title":
    "Rasentypen aktualisieren",
  "reseedEvent.field": "{name}",
  "reseedEvent.note": "Hinweis: {note}",
  "reseedEvent.seedingMethod": "Methode: {seedingMethod}",
  "reseedEvent.to": "Zu: {newGrassType}",
  "reseed.date.method.heading": "Datum, Methode & Grasart",
  "reseedEvent.list.title": "Vorherige Ereignisse",
  "reseedEvent.menu.editView": "Bearbeiten/Anzeigen",
  "reseedEvent.seedingMethod.option.PLOUGH_AND_POWER_HARROW":
    "Pflug und Kreiselegge",
  "reseedEvent.seedingMethod.option.DIRECT_DRILL": "Drillen",
  "reseedEvent.seedingMethod.option.SHALLOW_CULTIVATION":
    "Flache Bodenbearbeitung",
  "reseedEvent.seedingMethod.option.OVERSEED": "Nachsähen",
  "reseedEvent.seedingMethod.option.PLOUGH_POWER_HARROW_DRILL":
    "Pflügen → Kreiselegge & Drillmaschine",
  "reseedEvent.seedingMethod.option.PLOUGH_SHALLOW_CULTIVATE_DRILL":
    "Pflügen → Scheiben-/Zinkengrubber & Drillmaschine",
  "reseedEvent.seedingMethod.option.PLOUGH_CULTIPACK_SEED":
    "Pflügen → Kultipackersaat",
  "reseedEvent.seedingMethod.option.PLOUGH_DIRECT_DRILL":
    "Pflügen → Direktsaat",
  "reseedEvent.seedingMethod.option.SHALLOW_CULTIVATE_DRILL":
    "Scheiben-/Zinkengrubber & Drillmaschine",
  "reseedEvent.seedingMethod.option.DIRECT_DRILL_RESEED":
    "Direktsaat (Pfluglose Neuansaat)",
  "reseedEvent.seedingMethod.option.DIRECT_DRILL_OVERSEED":
    "Direktsaat Nachsaat",
  "reseedEvent.seedingMethod.option.TINE_DRILL_OVERSEED":
    "Grünlandstriegel mit Nachsaat",
  "reseedEvent.seedingMethod.option.BROADCAST_OVERSEED": "Breitsaat Nachsaat",
  "reseedEvent.seedingMethod.option.FROST_SEEDING": "Frostsaat",
  "reseedEvent.seedingMethod.text": "Methode",
  "diaryEntry.diaryEntryText.label": "Tagebuch Eintrag: {diaryEntryText}",
  "diaryEntry.show.titleName": "Tagebuch Eintrag",
  "diaryEntry.entryDate.label": "Datum {diaryEntryDate}",
  "diaryEntry.showImage.title": "Tagebuch Eintrag vom {diaryEntryDate}",
  "diaryEntry.delete.label": "Löschen",
  "diaryEntry.delete.confirm.label": "Ja",
  "diaryEntry.cancel.label": "Abbrechen",
  "diaryEntry.areYouSure.label":
    "Sind Sie sicher, dass Sie diesen Eintrag löschen möchten?",
  "diaryEntry.view.delete.menu": "Ansehen/Löschen",
  "diaryEntry.view.menu": "Ansehen",
  "diaryEntry.view.close.label": "Schliessen",
  "diaryEntry.deleted.notification": "Tagebuch Eintrag erfolgreich gelöscht.",
  "diaryEntry.delete.tooltip": "Tagebuch Eintrag löschen",
  "go.to.landmanagement.and.grazing.button": "Hof",
  "go.to.records": "Aufzeichnungen",
  "toolbar.records.view": "Aufzeichnungen",
  "inputs.outputs.reseeding.title": "Neu Sähen",
  "home.button.title": "Home",
  "pushNotification.fileShare.title": "Neue Datei geteilt",
  "pushNotification.fileShare.message":
    "{uploaderName} hat eine Datei mit Ihnen geteilt: {fileName}",
  "pushNotification.fileShare.dismiss": "Schließen",
  "pushNotification.fileShare.viewFiles": "Dateien anzeigen",
  "forceUpgrade.title": "Update erforderlich",
  "forceUpgrade.message":
    "Eine neue Version von Ruumi ist verfügbar. Bitte aktualisieren Sie die App, um fortzufahren.",
  "forceUpgrade.updateButton": "Jetzt aktualisieren",
  "softUpgrade.title": "Update verfügbar",
  "softUpgrade.message":
    "Eine neue Version von Ruumi mit Verbesserungen und Fehlerbehebungen ist verfügbar.",
  "softUpgrade.updateButton": "Jetzt aktualisieren",
  "softUpgrade.dismissButton": "Nicht jetzt",
  "common.additionalDetails.heading": "Zusätzliche Angaben (optional)",

  // Signup onboarding steps
  "signup.teaser.dialogTitle": "Einstieg",
  "signup.teaser.text":
    "Starten Sie noch heute Ihre kostenlose 60-Tage-Testphase. Geben Sie Felder ein und erhalten Sie innerhalb von Sekunden Einblicke.",
  "signup.userDetails.dialogTitle": "Kontodaten",
  "signup.userDetails.text":
    "Heute keine Zahlung erforderlich. Nur Ihre Kontaktdaten, damit wir Ihr Konto einrichten können.",
  "signup.farmDetails.dialogTitle": "Hofdetails",
  "signup.farmDetails.text":
    "Um Ihnen den bestmöglichen Service zu bieten, teilen Sie uns mit, welche Art von Hof Sie betreiben.",
  "signup.welcome.newTitle": "Willkommen bei Ruumi!",
  "signup.welcome.newSubtitle":
    "Richten wir Ihren Hof in wenigen einfachen Schritten ein. Wir führen Sie durch jeden einzelnen.",
  "signup.welcome.step1":
    "Erstellen Sie Ihren Hof und legen Sie seinen Standort fest",
  "signup.welcome.step2": "Zeichnen Sie Ihre Felder auf der Karte ein",
  "signup.welcome.step3": "Fügen Sie Ihre Tiergruppen hinzu",
  "signup.welcome.step4": "Beginnen Sie mit der Planung Ihrer Umtriebe",
  "signup.welcome.helpText": "Brauchen Sie Hilfe? Wir sind für Sie da.",

  // Onboarding checklist
  "onboarding.checklist.title": "Hof-Setup",
  "onboarding.checklist.progress": "{completed} von {total} abgeschlossen",
  "onboarding.checklist.dismiss": "Checkliste ausblenden",
  "onboarding.checklist.show": "Setup-Checkliste anzeigen",
  "onboarding.checklist.watchVideo": "Tutorial ansehen",
  "onboarding.step.createFarm.title": "Hof anlegen",
  "onboarding.step.createFarm.description":
    "Richten Sie Ihren Hofnamen und Standort ein, um loszulegen.",
  "onboarding.step.createFarm.action": "Hof anlegen",
  "onboarding.step.addField.title": "Erstes Feld hinzufügen",
  "onboarding.step.addField.description":
    "Zeichnen Sie Feldgrenzen auf der Karte. Wir berechnen die Grasbedeckung automatisch.",
  "onboarding.step.addField.action": "Feld hinzufügen",
  "onboarding.step.createAnimalGroup.title": "Tiergruppe anlegen",
  "onboarding.step.createAnimalGroup.description":
    "Fügen Sie Ihren Tierbestand hinzu, um den Weidebedarf zu verfolgen.",
  "onboarding.step.createAnimalGroup.action": "Tiere hinzufügen",
  "onboarding.step.assignField.title": "Felder Tieren zuordnen",
  "onboarding.step.assignField.description":
    "Verknüpfen Sie Felder mit Ihrer Tiergruppe, um mit der Rotationsplanung zu beginnen.",
  "onboarding.step.assignField.action": "Felder zuordnen",
  "onboarding.completion.title": "Alles bereit!",
  "onboarding.completion.message":
    "Ihr Hof ist startklar. Beginnen Sie mit der Verfolgung des Graswachstums und der Planung von Umtrieben, um Ihre Beweidung zu optimieren.",
  "onboarding.completion.helpText": "Haben Sie Fragen oder brauchen Sie Hilfe?",
  "onboarding.completion.helpLink": "Kontaktieren Sie uns",
  "onboarding.completion.button": "Los geht's!",

  // Map hints
  "map.movingHandles.hint":
    "Verschieben Sie die Punkte oder doppelklicken Sie auf die Feldpunkte, um sie auszuwählen.",

  // Farm livestock
  "farm.livestock.label": "Tiere",
  "farm.livestock.addAnimalGroup": "Tiergruppe hinzufügen",
  "animalGroupTypeCards.addMoreAnimalGroups": "+ TIERGRUPPE HINZUFÜGEN",

  // Animal group metrics
  "animalGroup.metrics.title": "Tiergruppen-Metriken",
  "animalGroup.metrics.animals": "Tiere",
  "animalGroup.metrics.currentField": "Aktuelles Feld",
  "animalGroup.metrics.notSet": "Nicht gesetzt",
  "animalGroup.metrics.assignedFields": "Zugeordnete Felder",
  "animalGroup.metrics.assignedArea": "Zugeordnete Fläche",
  "animalGroup.metrics.assignedArea.info":
    "Gesamtfläche aller dieser Tiergruppe zugeordneten Felder.",
  "animalGroup.metrics.stockingRate": "Besatzdichte",
  "animalGroup.metrics.stockingRate.info":
    "Großvieheinheiten pro Hektar. Berechnet als Gesamt-GVE geteilt durch die zugeordnete Fläche.",
  "animalGroup.metrics.grazingDaysAhead": "Verfügbare Weidetage",
  "animalGroup.metrics.grazingDaysAhead.info":
    "Verfügbare Weidetage basierend auf aktuellem Futterangebot und täglichem Futterbedarf.",
  "animalGroup.metrics.dailyFeedDemand": "Täglicher Futterbedarf",
  "animalGroup.metrics.dailyFeedDemand.info":
    "Täglicher Gesamttrockenmassekonsum aller Tiere in der Gruppe.",
  "animalGroup.metrics.animalCount.info":
    "Gesamtanzahl der Tiere in der Gruppe. GVE (Großvieheinheiten) rechnet verschiedene Tierarten in eine Standardeinheit um, wobei 1 GVE = 1 Milchkuh.",
  "animalGroup.metrics.forageAvailable.info":
    "Verfügbare Gesamttrockenmasse über allen zugeordneten Feldern oberhalb des Nachweideziels.",
  "animalGroup.metrics.none": "Keine",
  "animalGroup.metrics.stockClasses": "Tierklassen",
  "animalGroup.metrics.dryMatterAvailable": "TM Verfügbar",
  "animalGroup.metrics.dryMatterAvailableUnit": "kgTM",
  "animalGroup.metrics.forageAvailable": "Verfügbares Futter",
  "animalGroup.currentFieldNotSet": "Aktuelles Weidefeld nicht gesetzt",
  "animalGroup.setCurrentField": "Feld festlegen",
  "animalGroup.moveToShed": "In Stall bringen",
  "animalGroup.moveToShed.success": "Tiere in Stall gebracht",
  "animalGroup.moveToShed.error":
    "Tiere konnten nicht in den Stall gebracht werden",

  // Field type cards
  "fieldTypeCards.grain.title": "Getreidefelder",
  "fieldTypeCards.arable.title": "Ackerfelder",
  "fieldTypeCards.silage.title": "Silagefelder",
  "fieldTypeCards.pasture.title": "Weidefelder",
  "farm.fields.label": "Felder",
  "farm.fields.addField": "Feld hinzufügen",
  "fieldTypeCards.addMoreFields": "+ WEITERE FELDER HINZUFÜGEN",
  "fieldTypeCards.noFields": "Keine Felder",
  "fieldTypeCards.metrics.fields": "Felder",
  "fieldTypeCards.metrics.hectares": "Ha",
  "fieldTypeCards.metrics.dryMatterAvailable": "TM verfügbar",
  "fieldTypeCards.metrics.dryMatterAvailableUnit": "kgTM",
  "fieldTypeCards.metrics.growthRate": "Wachstumsrate",
  "fieldTypeCards.metrics.growthRateUnit": "kgTM/ha/Tag",
  "fieldTypeCards.metrics.totalCover": "TM Dichte",
  "fieldTypeCards.metrics.totalCoverUnit": "kgTM/ha",

  // Field prefixes
  "field.prefix.grazing": "Weidefeld",
  "field.prefix.silage": "Silagefield",
  "field.prefix.grain": "Getreidefeld",
  "field.prefix.arable": "Ackerfeld",

  // Farm add menu
  "farm.addMenu.inputs": "Einsatz und Ertrag hinzufügen",
  "farm.addMenu.farm": "Hof hinzufügen",

  // Reseed event title names
  "reseedEvents.show.titleName.RESEED": "{name} neu gesät",
  "reseedEvents.show.titleName.OVERSEED": "{name} nachgesät",

  // Grass wedge tooltip
  "grassWedge.tooltip.currentDM": "TM Dichte: {dm} kgTM/ha",

  // Field view livestock
  "fieldview.livestock.noAnimalGroupAssigned": "Keine Tiergruppe zugeordnet",
  "fieldview.livestock.assignAnimalGroupDescription":
    "Ordnen Sie diesem Feld eine Tiergruppe zu, um Tierbestandsinformationen zu sehen",
  "fieldview.livestock.assignNewGroup": "NEUE GRUPPE ZUORDNEN",
  "fieldview.livestock.title": "Tiere",
  "fieldview.livestock.dryMatterAvailable": "Verfügbare Trockenmasse",
  "fieldview.livestock.lastGrazed": "Zuletzt beweidet",
  "fieldview.livestock.daysAgo": "vor {days} Tagen",
  "fieldview.livestock.today": "Heute",
  "fieldview.livestock.currentlyGrazing": "Derzeit auf der Weide",
  "fieldview.livestock.currentlyGrazingSinceToday":
    "Derzeit auf der Weide (seit heute)",
  "fieldview.livestock.currentlyGrazingSince1Day":
    "Derzeit auf der Weide (1 Tag)",
  "fieldview.livestock.currentlyGrazingSinceDays":
    "Derzeit auf der Weide ({days} Tage)",
  "fieldview.livestock.never": "Nie",
  "fieldview.livestock.assignedGroup": "Zugeordnete Tiergruppe",
  "fieldview.livestock.change": "Ändern",
  "fieldview.livestock.assign": "Zuordnen",
  "fieldview.livestock.currentLocation": "Aktueller Standort",
  "fieldview.livestock.notSet": "Nicht gesetzt",
  "fieldview.livestock.moveHere": "Tiere hierher bewegen",
  "fieldview.livestock.assignDialogTitle": "Tiergruppe zuordnen",
  "fieldview.addImage": "Bild hinzufügen",

  // New signup
  "newSignup.userDetails.text1": "Willkommen bei ruumi!",
  "newSignup.userDetails.text2":
    "Registrieren Sie sich und nutzen Sie die Weide-App sofort!",
  "signup.confirmPassword.label": "Passwort bestätigen",
  "signup.confirmPassword.error": "Passwörter stimmen nicht überein",
  "signup.button.newSignup": "Zur App",
  "signup.signupError":
    "Fehler aufgetreten. Diese E-Mail-Adresse ist möglicherweise bereits registriert. Bitte verwenden Sie eine andere oder kontaktieren Sie den Support.",

  // Move animals to/from shed
  "moveAnimals.toShed.title": "In Stall bringen",
  "moveAnimals.fromShed.label": "Vom Stall in:",

  // Navigation
  "go.to.programmes": "Planer",
  "toolbar.farminsighs.title": "Hof-Einblicke",
  "go.to.file.management.button": "Dateien",
  "go.to.file.management.button.mobile": "Dateien",
  "go.to.farmer.dashboards.button": "Programm-Dashboards",
  "farmer.dashboard.label": "Landwirt-Dashboard",
  "farmer.dashboard.farmer.selection.label": "Landwirt auswählen",
  "farmer.dashboard.dashboard.selection.label": "Dashboard auswählen",
  "go.to.farm.insights": "Einblicke",
  "go.to.project.insights": "Programme",
  "go.to.project.insights.mobile": "Programme",
  "go.to.initial.screen.select": "Hofansicht",
  "go.to.accessible.farms.insights": "Landwirte",

  // Feed
  "toolbar.feed-overview.title": "Futter",
  "inputs.outputs.feed.purchase.title": "Futter",
  "feedPurchaseDetailView.button.addFeedPurchase.title":
    "Neuen Futterkauf hinzufügen",
  "feedPurchase.list.title": "Vorherige Ereignisse",
  "purchased.show.titleName": "Futterkauf: {name}",
  "feedPurchaseEvent.feedPurchaseDate": "Datum: {feedPurchasedDate}",
  "feedPurchaseEvent.feedType.text": "Futterart",
  "feedPurchase.feedType.option.HAYLAGE": "Haylage",
  "feedPurchase.feedType.option.SILAGE": "Grassilage",
  "feedPurchase.feedType.option.MAIZE_SILAGE": "Maissilage",
  "feedPurchase.feedType.option.WHOLECROP_SILAGE": "Ganzpflanzensilage",
  "feedPurchase.feedType.option.GRAIN": "Getreide",
  "feedPurchase.feedType.option.CONCENTRATED_FEED": "Kraftfutter",
  "feedPurchase.feedType.option.STRAW": "Stroh",
  "feedPurchase.feedType.option.HAY": "Heu",
  "feedPurchaseEvent.cost.label": "Kosten (in EUR)",
  "feedPurchase.feedUnit.option.KG": "Kg",
  "feedPurchase.feedUnit.option.TONNE": "Tonne",
  "feedPurchaseEvent.feedUnit.text": "Einheit",
  "feed.stock.summary.header": "Futter auf Lager",
  "feedPurchaseEvent.menu.editView": "Bearbeiten",
  "feedStock.summary.noFeedAvailable": "Kein Futter verfügbar",
  "feedPurchaseEvent.feedAmount.label": "Menge",
  "enterFeedPurchase.heading": "Futterkauf",
  "feedEventInput.removeFeed": "löschen",
  "feedEventInput.addFeed": "Neue Futterart hinzufügen",
  "feedEventInput.title": "Futterereignis",
  "feedEventInput.note": "Notiz",
  "feedEventDetailView.button.addFeedEvent.title":
    "Neues Futterereignis hinzufügen",
  "feedEventInput.AnimalGroups.text": "Tiergruppen",
  "notEnoughFeed.cancel.label": "Verstanden",
  "notEnoughFeed.title": "Nicht genug Futter verfügbar!",
  "cropTypeMissing.title": "Kultur fehlt in der Ertragsliste",
  "addFeedEvent.add.success": "Neues Futterereignis hinzugefügt.",
  "reatefeedPurchaseEvent.success": "Neues Futterkaufereignis hinzugefügt.",
  "feedItem.animalGroups.fedTo": "Gefüttert an: ",

  // Yield events
  "yieldEvent.yieldType.option.HAYLAGE": "Haylage",
  "yieldEvent.yieldType.option.SILAGE": "Grassilage",
  "yieldEvent.yieldType.option.HAY": "Heu",
  "yieldEvent.yieldType.option.STRAW": "Stroh",
  "yieldEvent.yieldType.option.MAIZE_SILAGE": "Maissilage",
  "yieldEvent.yieldType.option.WHOLECROP_SILAGE": "Ganzpflanzensilage",
  "yieldEvent.yieldType.option.WHEAT": "Weizen",
  "yieldEvent.yieldType.option.BARLEY": "Gerste",
  "yieldEvent.yieldType.option.OILSEED_RAPE": "Ölraps",
  "yieldEvent.yieldType.option.POTATO": "Kartoffeln",
  "yieldEvent.yieldType.option.MAIZ": "Mais",
  "yieldEvent.yieldType.option.CEREALS": "Getreide",
  "yieldEvent.yieldType.option.VEGETABLES_SALAD": "Gemüse/Salat",
  "yieldEvent.yieldType.option.OTHERS": "Sonstiges",
  "yieldEvent.yieldType.option.MEAT": "Fleisch",
  "yieldEvent.yieldType.option.MILK": "Milch",
  "yieldEvent.yieldType.option.GRASS": "Gras",
  "yieldEvent.yieldType.option.CROP": "Ernte",
  "yieldEventInput.title": "Erträge eingeben",
  "yieldEventInput.addYield": "Weiteren Ertrag hinzufügen",
  "yieldEvent.yieldAmount.label": "Menge",
  "yieldEvent.yieldType.text": "Ertragsart",
  "inputs.outputs.yield.title": "Erträge & Ernten",
  "toolbar.yield-overview.title": "Ertrag",
  "yieldEventDetailView.button.addYieldEvent.title":
    "Neues Ertragsereignis hinzufügen",
  "yieldEventInput.removeYield": "Ertrag entfernen",
  "yieldEvent.yieldType.MEAT": "Fleisch",
  "yieldEvent.yieldType.MILK": "Milch",
  "yieldEvent.yieldType.CROP": "Ernte",
  "yieldEvent.yieldType.GRASS": "Gras",
  "yieldEvent.soldOrKept.label.SOLD": "Verkauft",
  "yieldEvent.soldOrKept.label.KEPT": "Behalten",
  "yieldEvent.unitType.option.TONNE": "Tonne",
  "yieldEvent.unitType.option.KG": "Kg",
  "yieldEvent.unitType.option.LITRE": "Liter",
  "yieldEvent.unitType.option.M3": "M3",
  "yieldEvent.unitType.text": "Einheit",
  "yieldEvent.revenue.label": "Betrag (in EUR)",
  "yieldEvent.soldOrKept.text": "Verkauft/Behalten",
  "yieldEvent.fuel.label": "Kraftstoff (in Liter)",
  "yieldEvent.machinery.label": "Maschinen",
  "yieldEventInput.grassFields.text": "Grasfelder",
  "yieldEventInput.animalGroups.text": "Tiergruppen",
  "yieldEventInput.arableFields.text": "Ackerfelder",
  "yieldEvent.yieldEventDate": "Datum: {yieldEventDate}",
  "yieldEvent.grassFields.harvestedFrom": "Felder: ",
  "yieldEvent.arableFields.harvestedFrom": "Felder: ",
  "yieldEvent.animalGroups.harvestedFrom": "Tiergruppen: ",
  "yieldEvent.amount.sold": "{amount} verkauft für {soldPrice}",
  "yieldEvent.amount.kept": "{amount} behalten",
  "yieldEventInput.machinery.options.SPRAYER": "Sprühgerät",
  "yieldEventInput.machinery.options.MOWER": "Mäher",
  "yieldEventInput.machinery.options.SEED_BROADCASTER": "Sämaschine",
  "yieldEventInput.machinery.options.DIRECT_DRILL": "Direktdrillmaschine",
  "yieldEventInput.machinery.options.MANURE_SPREADER": "Miststreuer",
  "yieldEventInput.machinery.options.SLURRY_SPREADER": "Güllefass",
  "yieldEventInput.machinery.options.BALER": "Ballenpresse",
  "yieldEvent.menu.editView": "Bearbeiten",
  "yieldEventInput.machinery.label": "Maschinen",
  "addYieldEvent.add.success": "Neues Ertragsereignis hinzugefügt",
  "yield.stock.summary.header": "Erträge & Ernten auf Lager",

  // Fertilizer events
  "inputs.outputs.fertlizer.title": "Düngemittel",
  "inputs.outputs.combined.title": "Aufzeichnungen",
  "records.empty.title": "Noch keine Aufzeichnungen",
  "records.empty.description":
    "Aufzeichnungen Ihrer Hofaktivitäten erscheinen hier. Beginnen Sie damit, Felder hinzuzufügen und Ereignisse wie Aussaat, Fütterung oder Ernten zu erfassen.",
  "fertilizerEventInput.title": "Düngemittel",
  "fertilizerEvent.fertilizerType.label.ORGANIC": "Organisch",
  "fertilizerEvent.fertilizerType.label.SYNTHETIC": "Synthetisch",
  "fertilizerEvent.fertilizerType.label.LIME": "Kalk",
  "fertilizerEvent.fertilizerType.label.BIOSOLIDS": "Biofeststoffe",
  "fertilizerEvent.fertilizerType.label.BIODIGESTATE": "Biogasgärreste",
  "fertilizerEvent.fertilizerType.label.COMPOST": "Kompost",
  "fertilizerEvent.fertilizerType.label.OTHER": "Sonstiges",
  "fertilizerEvent.organicFertilizerType.label.FYM": "Stallmist",
  "fertilizerEvent.organicFertilizerType.label.SLURRY": "Gülle",
  "fertilizerEvent.organicFertilizerType.label.DIRTY_WATER": "Schmutzwasser",
  "fertilizerEventInput.animalType.options.DAIRY_CATTLE": "Milchvieh",
  "fertilizerEventInput.animalType.options.BEEF_CATTLE": "Fleischrinder",
  "fertilizerEventInput.animalType.options.PIG": "Schwein",
  "fertilizerEventInput.animalType.options.SHEEP": "Schaf",
  "fertilizerEventInput.animalType.options.HORSE": "Pferd",
  "fertilizerEventInput.animalType.options.CHICKEN_LITTER": "Hühnermist",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.BROADCAST_SPREADER":
    "Breitverteiler",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.MUCK_SPREADER":
    "Stalldungstreuer (Heckaustrag)",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.IRRIGATION":
    "Beregnung (Regner / Beregnungsmaschine)",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.DISC_INJECTOR":
    "Scheibeniinjektor",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.TRAILING_SHOE":
    "LESS: Schleppschuh",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.DRIBBLE_BAR":
    "LESS: Bandverteiler / Schleppschlauch",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.SHALLOW_INJECTION":
    "LESS: Flache Injektion",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.DEEP_INJECTION":
    "LESS: Tiefe Injektion",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.SPLASH_PLATE":
    "Prallteller",
  "fertilizerEvent.fertilizerProperties.applicationMethod.options.OTHER":
    "Sonstiges",
  "fertilizerProperties.applicationMethod": "Ausbringungsmethode",
  "fertilizerEvent.fertilizerProperties.organicType.text":
    "Art des organischen Düngemittels",
  "fertilizerEventInput.animalType.label": "Tierart",
  "fertilizerEventInput.machinery.label": "Maschinen",
  "fertilizerEvent.fuel.label": "Kraftstoff (in Liter)",
  "fertilizerEventInput.fields.text": "Feld(er)",
  "fertilizerEventDetailView.button.addFertilizerEvent.title":
    "Düngemittelereignis hinzufügen",
  "fertilizerInput.fertilizerType.label": "Art des Düngemittels",
  "organicFertilizer.imported.label": "Importiert?",
  "fertilizerEvent.totalAmount.label": "Ausbringungsmenge",
  "fertilizerEvent.totalAmount.rateLabel": "Ausbringungsmenge",
  "fertilizerEvent.totalAmount.totalLabel": "Gesamtmenge",
  "fertilizerEvent.amountMode.total": "Gesamtmenge",
  "fertilizerEvent.amountMode.rate": "Ausbringungsmenge",
  "fertilizerEvent.amount.rateHelper": "≈ {rate} {unit} auf {area} ha",
  "fertilizerEvent.amount.totalHelper": "≈ {total} {unit} gesamt auf {area} ha",
  "fertilizerInput.totalAmountUnit.label": "Einheit",
  "fertilizerEvent.totalAmountUnit.option.KG": "kg/ha",
  "fertilizerEvent.totalAmountUnit.option.TONNE": "t/ha",
  "fertilizerEvent.totalAmountUnit.option.M3": "m³/ha",
  "fertilizerEvent.totalAmountUnit.option.GALLONS": "Gallonen",
  "fertilizerEvent.totalAmountUnit.totalOption.KG": "kg",
  "fertilizerEvent.totalAmountUnit.totalOption.TONNE": "t",
  "fertilizerEvent.totalAmountUnit.totalOption.M3": "m³",
  "fertilizerEvent.totalAmountUnit.totalOption.GALLONS": "Gallonen",
  "fertilizerEvent.field.name": "Feld:",
  "fertilizerEvent.fertilizerEventDate": "{fertilizerEventDate}",
  "fertilizerEvent.typeOfNitrogen.label.UREA": "Harnstoff",
  "fertilizerEvent.typeOfNitrogen.label.PROTECTED_UREA":
    "Stabilisierter Harnstoff",
  "fertilizerEvent.typeOfNitrogen.label.UAN": "UAN",
  "fertilizerEvent.typeOfNitrogen.label.CAN": "KAS",
  "fertilizerEvent.typeOfNitrogen.label.CN": "Kalkstickstoff",
  "fertilizerEvent.typeOfNitrogen.label.AN": "Ammonsalpeter",
  "fertilizerEvent.typeOfNitrogen.label.OTHER": "Sonstiges",
  "fertilizerEvent.fertilizerProperties.kPercentage.label": "%K",
  "fertilizerEvent.fertilizerProperties.pPercentage.label": "%P",
  "fertilizerEvent.fertilizerProperties.nPercentage.label": "%N",
  "fertilizerEvent.fertilizerProperties.productName.label": "Produktname",
  "fertilizerEvent.fertilizerProperties.typeOfNitrogen.text": "Stickstoffart",
  "fertilizerEvent.fertilizerProperties.phPriorToApplication.label":
    "pH vor Ausbringung",
  "toolbar.fertilizer-overview.title": "Düngemittel",
  "updateFertilizerEvent.add.success":
    "Düngemittelereignis erfolgreich aktualisiert.",
  "addFertilizerEvent.add.success":
    "Düngemittelereignis erfolgreich hinzugefügt.",

  // Reseed event details
  "reseedEvent.machinery.label": "Maschinen",
  "reseedEvent.reseedType.OVERSEED": "Nachsaat",
  "reseedEvent.reseedType.RESEED": "Neuansaat",
  "reseedEvent.productName.label": "Saatgutproduktname",
  "reseedEvent.productCost.label": "Kosten (£, optional)",
  "reseedEvent.seedingRate.label": "Saatgutmenge (kg/ha)",
  "reseedEvents.RESEED.explanation":
    "Bei einer Neuansaat werden neue Samen in kahle oder abgenutzte Bereiche eingebracht, was die Grasart ändert, z. B. von Weidelgras zu einem Kräutermischgemisch.",
  "reseedEvents.OVERSEED.explanation":
    "Beim Nachsäen werden gleiche Samen auf einem Feld ausgebracht, um kahle Stellen zu reduzieren oder die Keimung bestimmter Samen zu verbessern, während die bestehende Saatart erhalten bleibt.",
  "reseedEvent.totalAmountUnit.label": "Einheitsart",
  "reseedEvent.totalAmountUnit.label.G": "g",
  "reseedEvent.totalAmountUnit.label.KG": "kg",
  "reseedEvent.totalAmountUnit.label.TONNE": "Tonne",
  "reseedEvent.totalAmount.label": "Gesamtmenge",
  "reseedEvent.amount.heading": "Ausgebrachte Menge",
  "reseedEvent.amountMode.rate": "Saatmenge",
  "reseedEvent.amount.rateHelper": "≈ {total} kg auf {area} ha",
  "reseedEvent.amount.totalHelper": "≈ {rate} kg/ha auf {area} ha",

  // Field preparation
  "toolbar.field-preparation-overview.title": "Feldvorbereitung",
  "fieldPreparationEvent.fields.name": "Felder",
  "fieldPreparationEventDetailView.button.addFieldPreparationEvent.title":
    "Neues Feldvorbereitungsereignis hinzufügen",
  "inputs.outputs.fieldPreparation.title": "Feldvorbereitung",
  "fieldPreparationEvent.fieldPreparationEventDate":
    "{fieldPreparationEventDate}",
  "fieldPreparationEventInput.title": "Feldvorbereitungsereignis",
  "fieldPreparationEventInput.fields.text": "Feld(er)",
  "fieldPreparationEvent.fuel.label": "Kraftstoff",
  "fieldPreparationEventInput.machinery.label": "Maschinen",
  "updateFieldPreparationEvent.add.success":
    "Feldvorbereitungsereignis aktualisiert",
  "addFieldPreparationEvent.add.success":
    "Feldvorbereitungsereignis hinzugefügt",
  "fieldPreparationEvent.machinery.name": "Maschinen",
  "fieldPreparationEvent.fuel.name": "Kraftstoff",
  "fieldPreparationEvent.note.name": "Notiz",

  // Section headings
  "fertilizer.amount.cost.heading": "Menge & Kosten",
  "fertilizerEvent.productCost.label": "Kosten (£, optional)",
  "fertilizer.operational.cost.heading": "Betriebskosten",
  "fertilizerEvent.operationalCost.label": "Kosten (in EUR)",
  "reseed.date.type.heading": "Datum & Art",
  "reseed.grass.method.heading": "Grasart & Aussaatmethode",
  "reseed.product.details.heading": "Produktdetails",
  "reseed.amount.cost.heading": "Aussaatmenge & Kosten",
  "reseed.operational.cost.heading": "Betriebskosten",
  "reseed.notes.heading": "Notizen",
  "feedPurchase.date.heading": "Datum",
  "feedPurchase.typeUnit.heading": "Futterart & Einheit",
  "feedPurchase.amountCost.heading": "Menge & Kosten",
  "feedPurchase.notes.heading": "Notizen",
  "fieldPreparation.date.heading": "Datum",
  "fieldPreparation.notes.heading": "Notizen",
  "feed.date.heading": "Datum",
  "feed.details.heading": "Futterdetails",
  "feed.notes.heading": "Notizen",
  "fertilizer.date.type.heading": "Datum & Düngemittelart",
  "fertilizer.properties.heading": "Düngemitteleigenschaften",
  "fertilizer.notes.heading": "Notizen",
  "yield.date.type.heading": "Datum & Ertragsart",
  "yield.details.heading": "Ertragsdetails",
  "yield.notes.heading": "Notizen",

  // File management
  "fileEntries.fileUploadType.label.FERTILISER_RECEIPT": "Düngemittelquittung",
  "fileEntries.fileUploadType.label.FERTILISER_BAG": "Düngemittelsack",
  "fileEntries.fileUploadType.label.SEED_MIXES_RECEIPT":
    "Saatmischungsquittung",
  "fileEntries.fileUploadType.label.SEED_MIXES_BAG": "Saatmischungssack",
  "fileEntries.fileUploadType.label.FIELD_IMAGES": "Feldbilder",
  "fileEntries.fileUploadType.label.SOIL_TEST_REPORT": "Bodenanalysebericht",
  "fileEntries.fileUploadType.label.WATER_TEST_REPORT": "Wasseranalysebericht",
  "fileEntries.fileUploadType.label.MILK_RECORDING_REPORT":
    "Milchleistungsbericht",
  "fileEntries.fileUploadType.label.CARCASS_REPORT": "Schlachtbericht",
  "fileEntries.fileUploadType.label.CARBON_AUDIT_REPORT":
    "CO2-Fußabdruckbericht",
  "fileEntries.fileUploadType.label.SOIL_ENVIRONMENT_REPORT":
    "Boden- und Umweltbericht",
  "fileEntries.fileUploadType.label.DETAILED_NUTRIENT_MANAGEMENT_PLAN":
    "Detaillierter Nährstoffmanagementplan",
  "fileEntries.fileUploadType.label.BIODIVERSITY_ACTION_PLAN":
    "Biodiversitäts-Aktionsplan",
  "fileEntries.fileUploadType.label.BIODIVERSITY_HABITAT_MAP":
    "Biodiversitäts-Habitatkarte",
  "fileEntries.fileUploadType.label.SFI_ADVICE_REPORT": "SFI-Beratungsbericht",
  "fileEntries.fileUploadType.label.BIODIVERSITY_SUMMARY_FLOWER":
    "Biodiversitätszusammenfassung",
  "fileEntries.fileUploadType.label.ACTION_EVIDENCE_PHOTO":
    "Maßnahmennachweis-Foto",
  "fileEntries.fileUploadType.label.ACTION_EVIDENCE_FILE":
    "Maßnahmennachweis-Datei",
  "fileEntries.fileUploadType.label.PROGRAMME_CONSENT_FORM":
    "Programm-Einverständniserklärung",
  "fileEntries.fileUploadType.label": "Datei-Upload-Typ",
  "fileEntries.associatedUserId.label": "Benutzer, dem diese Datei gehört",
  "fileEntry.creationDate": "{creationDate}",
  "fileManagementDetailView.button.addFile.title": "Neue Datei hochladen",
  "toolbar.file-management.title": "Dateiverwaltung",
  "inputs.outputs.fileUpload.title": "Dateiverwaltung",
  "fileEntry.menu.editView": "Dateieintrag bearbeiten",
  "fileEntries.fileUploadType.name": "Typ",
  "fileEntries.associatedUser.name": "Landwirt",
  "fileEntries.createdByUser.name": "Hochgeladen von",
  "updateFileEntry.add.success": "Dateieintrag aktualisiert",
  "fileEntry.add.success": "Dateieintrag hinzugefügt",
  "fileEntry.menu.download": "Herunterladen",
  "fileEntries.fileName.name": "Dateiname",
  "fileEntryInput.title": "Datei hochladen",
  "fileEntryInput.button": "Datei auswählen",
  "fileEntry.owned.closeable.list": "Meine Uploads",
  "fileEntry.not.owned.closeable.list":
    "Von jemand anderem für mich hochgeladen",
  "fileEntry.menu.delete": "Löschen",
  "fileEntry.delete.success": "Datei erfolgreich gelöscht",
  "fileEntry.relevant.for.questionnaire.closeable.list": "Relevante Dateien",
  "confirmdeletedialog.title": "Datei löschen",
  "confirmdeletedialog.text":
    "Möchten Sie die Datei {fileName} wirklich löschen?",
  "who.can.see.my.files": "Wer kann meine Dateien sehen?",
  "confirm.sumbit.file.upload.warning.text":
    "Diese Datei wird auch mit diesem Benutzer geteilt: ",
  "cancel.file.upload.submit.label": "Abbrechen",
  "confirm.file.upload.submit.label": "Hochladen",
  "upload.file.confirm.title": "Datei hochladen",
  "confirm.sumbit.file.upload.general.text":
    "Möchten Sie diese Datei wirklich hochladen?",
  "who.can.see.my.files.explanation":
    "Nur Benutzer, die eine Datei für Sie hochladen, können diese Datei außer Ihnen sehen. Dateien, die Sie für jemand anderen hochladen, sind nur für Sie und die Person sichtbar, für die Sie die Datei hochgeladen haben.",

  // Arable type
  "arableType.not.set.yet": "Noch kein Fruchtart festgelegt",
  "arableType.details.type.notsetyet": "Noch nicht festgelegt",
  "file.uploaded.for": "Hochgeladen für {receiverName}",

  // Insights navigation
  "go.to.farms.insights": "Hofeinblicke",
  "toolbar.farmsinsighs.title": "Hofeinblicke",
  "toolbar.projectinsighs.title": "Projekteinblicke",
  "projects.dashboard.label": "Projekt-Dashboards",
  "corporate.farmers.dashboard.label": "Landwirt-Dashboards",
  "toolbar.projectinsights.title": "Projekteinblicke",

  // Field detail
  "fieldDetail.title": "Feldmetriken",
  "fieldDetail.metrics.title": "Feldmetriken",
  "fieldDetail.availableDryMatter": "Verfügbare Trockenmasse",
  "fieldDetail.grazingDaysAhead": "Verfügbare Weidetage",
  "fieldDetail.totalCover": "TM Dichte",
  "fieldDetail.area": "Fläche",
  "fieldDetail.grassType": "Grasart",
  "fieldDetail.animals": "Tiere",
  "fieldDetail.coverFeedback": "Sieht das richtig aus?",
  "fieldDetail.coverFeedback.thankYou": "Danke für Ihr Feedback!",
  "fieldDetail.coverFeedback.enterCorrectValue": "Richtigen Wert eingeben",
  "fieldDetail.setGrassType": "Grasart festlegen",
  "fieldDetail.selectGrassType": "Grasart auswählen",
  "fieldDetail.setGrassTypeHint":
    "Hilft bei der Verbesserung der Bestandsschätzungen",
  "fieldDetail.setGrassTypeButton": "Festlegen",

  // Programmes / dashboards
  "no.accessible.farmer.dashboards.available":
    "Dieses Dashboard könnte Landwirteinblicke aus laufenden Programmen anzeigen. Kontaktieren Sie johannes@ruumi.io für mehr Informationen!",
  "no.programmes.available.body":
    "Nehmen Sie an einem Programm teil, um das Beste aus ruumi herauszuholen! \n Wir arbeiten mit der Lebensmittelversorgungskette zusammen, um Ihnen dabei zu helfen, die Effizienz und Nachhaltigkeit Ihres Hofes zu verbessern. Durch einen kurzen 5-minütigen Assessment können wir feststellen, ob Sie von einem Programm in Ihrer Versorgungskette profitieren könnten.",
  "no.programmes.available.body.web":
    "Wir arbeiten mit der Lebensmittelversorgungskette zusammen, um Ihnen dabei zu helfen, die Effizienz und Nachhaltigkeit Ihres Hofes zu verbessern. Durch einen kurzen 5-minütigen Assessment können wir feststellen, ob Sie von einem Programm in Ihrer Versorgungskette profitieren könnten.",

  // Farm switch
  "farmSwitch.viewDataForDifferentSite":
    "Daten für einen anderen Standort anzeigen",
  "farmSwitch.current": "(Aktuell)",
  "farmView.loading.title": "Wird geladen",
  "farmView.loading.description":
    "Tier- und Feldinformationen von Ihrem Standort ansehen!",

  // Feed purchase updates
  "updateFeedPurchase.success": "Futterkaufereignis erfolgreich aktualisiert.",
  "createfeedPurchaseEvent.success":
    "Futterkaufereignis erfolgreich hinzugefügt.",

  // No fields modal
  "noFieldsModal.title":
    "Geben Sie Ihre Betriebsnummer ein, um Ihren Hof anzuzeigen",
  "noFieldsModal.description":
    "Sehen Sie Ihre Felder aus dem Weltall — geben Sie Ihre Betriebsnummer ein, um Satelliteneinblicke für jeden Hektar zu erhalten, den Sie bewirtschaften",
  "noFieldsModal.import.button": "Felder importieren",
  "noFieldsModal.manual.button": "Felder manuell hinzufügen",
  "noFieldsModal.manual.title":
    "Zeichnen Sie Ihre Felder oder senden Sie Ihre Datei an Ruumi und wir helfen Ihnen",
  "noFieldsModal.manual.draw.title": "Feldgrenzen zeichnen",
  "noFieldsModal.manual.draw.description":
    "Verwenden Sie das Ruumi-Werkzeug, um Ihre Feldgrenzen zu zeichnen",
  "noFieldsModal.manual.support.title": "Ruumi kontaktieren",
  "noFieldsModal.manual.support.description":
    "Senden Sie uns Ihre Datei und wir fügen Ihre Felder für Sie hinzu",
  "noFieldsModal.draw.title": "Feldgrenzen zeichnen",
  "noFieldsModal.support.title": "Ruumi kontaktieren",
  "noFieldsModal.back": "Zurück zum Import",
  "noFieldsModal.import.error": "Felder konnten nicht importiert werden",

  // Programmes
  "programmes.toolbar.title": "Programme",
  "programmes.title": "Programme",
  "programmes.viewProgramme": "Programm anzeigen",
  "programmes.notStarted": "Nicht begonnen",
  "programmes.inProgress": "In Bearbeitung",
  "programmes.quickAssessment": "Kurzassessment",
  "programmes.planActions": "Maßnahmen planen",
  "programme.in.developement":
    "Das Programm mit Ihrer Versorgungskette befindet sich noch in der Entwicklung. Wir melden uns, sobald wir bereit sind! Nutzen Sie in der Zwischenzeit die ruumi-App und zögern Sie nicht, uns zu kontaktieren, wenn Sie Fragen haben.",
  "action.plan.submitted.thank.you":
    "Unten sehen Sie die Maßnahmen, die Sie als Teil des Programms ausgewählt haben. Denken Sie daran, Nachweise aufzubewahren, und zögern Sie nicht, ruumi oder Ihren Berater zu kontaktieren, wenn Sie Hilfe benötigen.",
  "action.plan.submitted.but.not.available.yet":
    "Vielen Dank für die Einreichung Ihres Maßnahmenplans! Ihr Programmberater wird Ihre Auswahl prüfen und sich in Kürze mit den nächsten Schritten bei Ihnen melden. Nutzen Sie in der Zwischenzeit die ruumi-App und zögern Sie nicht, uns zu kontaktieren, wenn Sie Fragen haben.",
  "quick.assessment.thank.you":
    "Vielen Dank, dass Sie sich die Zeit genommen haben, uns mehr über Ihren Hof zu erzählen!\nFalls wir ein Programm finden, das für Sie nützlich sein könnte, melden wir uns. Nutzen Sie in der Zwischenzeit die ruumi-App und zögern Sie nicht, uns zu kontaktieren, wenn Sie Fragen haben.",
  "quick.assessment.thank.you.web":
    "Falls wir ein Programm finden, das für Sie nützlich sein könnte, melden wir uns. Nutzen Sie in der Zwischenzeit die ruumi-App und zögern Sie nicht, uns zu kontaktieren, wenn Sie Fragen haben.",
  "farmSwitch.addNewFarm": "Neuen Hof hinzufügen",

  // Planner
  "planner.title": "Planer",
  "planner.programmes.title": "Meine Programme",
  "planner.programmes.noProgrammes":
    "Sie sind noch in keinen Programmen angemeldet.",
  "planner.programmes.buyerSurvey.title": "Wer kauft Ihre Produkte?",
  "planner.programmes.buyerSurvey.description":
    "Teilen Sie uns mit, wer Ihre Produkte kauft, damit wir Programme finden können, die zu Ihrer Versorgungskette passen.",
  "planner.programmes.buyerSurvey.button":
    "Uns mitteilen, wer Ihre Produkte kauft",
  "planner.programmes.buyerSurvey.dialogTitle":
    "Uns mitteilen, wer Ihre Produkte kauft",
  "planner.programmes.buyerSurvey.thankYou":
    "Danke, dass Sie uns mitgeteilt haben, wer Ihre Produkte kauft. Wir nutzen dies, um geeignete Versorgungskettenprogramme für Ihren Hof zu erkunden.",
  "planner.feedPlanning.title": "Futterplanung",
  "planner.feedPlanning.noStock":
    "Kein Futterbestand erfasst. Fügen Sie Futterkäufe hinzu, um Ihren Bestand zu verfolgen.",
  "planner.viewAll": "Alle anzeigen",
  "planner.calendar.title": "Kalender",
  "planner.actionPlan.title": "Maßnahmenplan",
  "planner.routines.title": "Routinen",
  "planner.routines.customRoutines.title": "Weitere Routinen",
  "planner.routines.customRoutines.description":
    "Erstellen und verfolgen Sie Ihre eigenen wiederkehrenden Hofaufgaben wie das Überprüfen von Wassertrögen oder das Umstellen von Tieren.",
  "planner.comingSoon": "Demnächst verfügbar",
  "planner.farmActivities.title": "Hofaktivitäten",
  "planner.farmActivities.tabs.actionPlan": "Maßnahmenplan",
  "planner.farmActivities.tabs.calendar": "Kalender",
  "planner.farmActivities.tabs.routines": "Routinen",
  "planner.farmActivities.quickAssessment.title": "Loslegen",
  "planner.farmActivities.quickAssessment.description":
    "Führen Sie ein Kurzassessment durch, um Programme zu finden, die die Effizienz und Nachhaltigkeit Ihres Hofes verbessern können.",
  "planner.farmActivities.quickAssessment.button":
    "Erzählen Sie uns von Ihrem Hof",
  "planner.farmActivities.noActions.withProgramme":
    "Sie haben noch keine Maßnahmen geplant. Besuchen Sie Ihr Programm, um mit der Planung zu beginnen.",
  "planner.farmActivities.noActions.assessmentComplete":
    "Vielen Dank für das Ausfüllen des Assessments! Wir melden uns, wenn wir ein geeignetes Programm für Ihren Hof finden.",
  "planner.farmActivities.noActions.startPlanning":
    "Klicken Sie auf ein Programm unten, um mit der Planung Ihrer Maßnahmen zu beginnen.",
  "planner.farmActivities.calendar.title": "Saisonkalender",
  "planner.farmActivities.calendar.description":
    "Planen und visualisieren Sie Ihre Hofaktivitäten über das Jahr.",
  "planner.farmActivities.routines.title": "Wiederkehrende Routinen",
  "planner.farmActivities.routines.description":
    "Richten Sie tägliche, wöchentliche und monatliche Hofroutinen ein und verfolgen Sie diese.",
  "go.to.planner": "Planer",

  // Insights
  "insights.yieldInsights.title": "Ertragseinblicke",
  "insights.farmPerformance.title": "Hofleistung",
  "insights.assessments.title": "Assessments & Empfehlungen",
  "insights.assessments.description":
    "Sehen Sie Boden-, Biodiversitäts- und Wasserassessments mit Empfehlungen für Ihren Hof.",
  "insights.noDashboard": "Für dieses Programm ist kein Dashboard verfügbar",
  "insights.dashboardLoadError": "Dashboard konnte nicht geladen werden",
  "planner.assessmentComplete":
    "Vielen Dank für das Ausfüllen des Assessments! Wir melden uns, wenn wir ein geeignetes Programm für Ihren Hof finden.",
};
